webpackJsonp([1],Array(69).concat([
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_js_type_js__ = __webpack_require__(161);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ef3acbf4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Type_vue__ = __webpack_require__(247);
function injectStyle (ssrContext) {
  __webpack_require__(227)
}
var normalizeComponent = __webpack_require__(13)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_js_type_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ef3acbf4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Type_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 86 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(88)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 88 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 89 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(91);
var defined = __webpack_require__(92);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(113);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 92 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 93 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(97);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define("VueLoading",[],e):"object"==typeof exports?exports.VueLoading=e():t.VueLoading=e()}("undefined"!=typeof self?self:this,function(){return function(t){var e={};function i(n){if(e[n])return e[n].exports;var r=e[n]={i:n,l:!1,exports:{}};return t[n].call(r.exports,r,r.exports,i),r.l=!0,r.exports}return i.m=t,i.c=e,i.d=function(t,e,n){i.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:n})},i.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},i.t=function(t,e){if(1&e&&(t=i(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var n=Object.create(null);if(i.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var r in t)i.d(n,r,function(e){return t[e]}.bind(null,r));return n},i.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return i.d(e,"a",e),e},i.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},i.p="",i(i.s=1)}([function(t,e,i){},function(t,e,i){"use strict";i.r(e);var n="undefined"!=typeof window?window.HTMLElement:Object,r={mounted:function(){document.addEventListener("focusin",this.focusIn)},methods:{focusIn:function(t){if(this.isActive&&t.target!==this.$el&&!this.$el.contains(t.target)){var e=this.container?this.container:this.isFullPage?null:this.$el.parentElement;(this.isFullPage||e&&e.contains(t.target))&&(t.preventDefault(),this.$el.focus())}}},beforeDestroy:function(){document.removeEventListener("focusin",this.focusIn)}};function a(t,e,i,n,r,a,o,s){var u,l="function"==typeof t?t.options:t;if(e&&(l.render=e,l.staticRenderFns=i,l._compiled=!0),n&&(l.functional=!0),a&&(l._scopeId="data-v-"+a),o?(u=function(t){(t=t||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext)||"undefined"==typeof __VUE_SSR_CONTEXT__||(t=__VUE_SSR_CONTEXT__),r&&r.call(this,t),t&&t._registeredComponents&&t._registeredComponents.add(o)},l._ssrRegister=u):r&&(u=s?function(){r.call(this,this.$root.$options.shadowRoot)}:r),u)if(l.functional){l._injectStyles=u;var c=l.render;l.render=function(t,e){return u.call(e),c(t,e)}}else{var d=l.beforeCreate;l.beforeCreate=d?[].concat(d,u):[u]}return{exports:t,options:l}}var o=a({name:"spinner",props:{color:{type:String,default:"#000"},height:{type:Number,default:64},width:{type:Number,default:64}}},function(){var t=this.$createElement,e=this._self._c||t;return e("svg",{attrs:{viewBox:"0 0 38 38",xmlns:"http://www.w3.org/2000/svg",width:this.width,height:this.height,stroke:this.color}},[e("g",{attrs:{fill:"none","fill-rule":"evenodd"}},[e("g",{attrs:{transform:"translate(1 1)","stroke-width":"2"}},[e("circle",{attrs:{"stroke-opacity":".25",cx:"18",cy:"18",r:"18"}}),this._v(" "),e("path",{attrs:{d:"M36 18c0-9.94-8.06-18-18-18"}},[e("animateTransform",{attrs:{attributeName:"transform",type:"rotate",from:"0 18 18",to:"360 18 18",dur:"0.8s",repeatCount:"indefinite"}})],1)])])])},[],!1,null,null,null);o.options.__file="spinner.vue";var s=o.exports,u=a({name:"dots",props:{color:{type:String,default:"#000"},height:{type:Number,default:240},width:{type:Number,default:60}}},function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("svg",{attrs:{viewBox:"0 0 120 30",xmlns:"http://www.w3.org/2000/svg",fill:t.color,width:t.width,height:t.height}},[i("circle",{attrs:{cx:"15",cy:"15",r:"15"}},[i("animate",{attrs:{attributeName:"r",from:"15",to:"15",begin:"0s",dur:"0.8s",values:"15;9;15",calcMode:"linear",repeatCount:"indefinite"}}),t._v(" "),i("animate",{attrs:{attributeName:"fill-opacity",from:"1",to:"1",begin:"0s",dur:"0.8s",values:"1;.5;1",calcMode:"linear",repeatCount:"indefinite"}})]),t._v(" "),i("circle",{attrs:{cx:"60",cy:"15",r:"9","fill-opacity":"0.3"}},[i("animate",{attrs:{attributeName:"r",from:"9",to:"9",begin:"0s",dur:"0.8s",values:"9;15;9",calcMode:"linear",repeatCount:"indefinite"}}),t._v(" "),i("animate",{attrs:{attributeName:"fill-opacity",from:"0.5",to:"0.5",begin:"0s",dur:"0.8s",values:".5;1;.5",calcMode:"linear",repeatCount:"indefinite"}})]),t._v(" "),i("circle",{attrs:{cx:"105",cy:"15",r:"15"}},[i("animate",{attrs:{attributeName:"r",from:"15",to:"15",begin:"0s",dur:"0.8s",values:"15;9;15",calcMode:"linear",repeatCount:"indefinite"}}),t._v(" "),i("animate",{attrs:{attributeName:"fill-opacity",from:"1",to:"1",begin:"0s",dur:"0.8s",values:"1;.5;1",calcMode:"linear",repeatCount:"indefinite"}})])])},[],!1,null,null,null);u.options.__file="dots.vue";var l=u.exports,c=a({name:"bars",props:{color:{type:String,default:"#000"},height:{type:Number,default:40},width:{type:Number,default:40}}},function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("svg",{attrs:{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 30 30",height:t.height,width:t.width,fill:t.color}},[i("rect",{attrs:{x:"0",y:"13",width:"4",height:"5"}},[i("animate",{attrs:{attributeName:"height",attributeType:"XML",values:"5;21;5",begin:"0s",dur:"0.6s",repeatCount:"indefinite"}}),t._v(" "),i("animate",{attrs:{attributeName:"y",attributeType:"XML",values:"13; 5; 13",begin:"0s",dur:"0.6s",repeatCount:"indefinite"}})]),t._v(" "),i("rect",{attrs:{x:"10",y:"13",width:"4",height:"5"}},[i("animate",{attrs:{attributeName:"height",attributeType:"XML",values:"5;21;5",begin:"0.15s",dur:"0.6s",repeatCount:"indefinite"}}),t._v(" "),i("animate",{attrs:{attributeName:"y",attributeType:"XML",values:"13; 5; 13",begin:"0.15s",dur:"0.6s",repeatCount:"indefinite"}})]),t._v(" "),i("rect",{attrs:{x:"20",y:"13",width:"4",height:"5"}},[i("animate",{attrs:{attributeName:"height",attributeType:"XML",values:"5;21;5",begin:"0.3s",dur:"0.6s",repeatCount:"indefinite"}}),t._v(" "),i("animate",{attrs:{attributeName:"y",attributeType:"XML",values:"13; 5; 13",begin:"0.3s",dur:"0.6s",repeatCount:"indefinite"}})])])},[],!1,null,null,null);c.options.__file="bars.vue";var d=c.exports,f=a({name:"vue-loading",mixins:[r],props:{active:Boolean,programmatic:Boolean,container:[Object,Function,n],isFullPage:{type:Boolean,default:!0},transition:{type:String,default:"fade"},canCancel:Boolean,onCancel:{type:Function,default:function(){}},color:String,backgroundColor:String,opacity:Number,width:Number,height:Number,loader:{type:String,default:"spinner"}},data:function(){return{isActive:this.active}},components:{Spinner:s,Dots:l,Bars:d},beforeMount:function(){this.programmatic&&(this.container?(this.isFullPage=!1,this.container.appendChild(this.$el)):document.body.appendChild(this.$el))},mounted:function(){this.programmatic&&(this.isActive=!0),document.addEventListener("keyup",this.keyPress)},methods:{cancel:function(){this.canCancel&&this.isActive&&(this.hide(),this.onCancel.apply(null,arguments))},hide:function(){var t=this;this.$emit("hide"),this.$emit("update:active",!1),this.programmatic&&(this.isActive=!1,setTimeout(function(){var e;t.$destroy(),void 0!==(e=t.$el).remove?e.remove():e.parentNode.removeChild(e)},150))},keyPress:function(t){27===t.keyCode&&this.cancel()}},watch:{active:function(t){this.isActive=t}},beforeDestroy:function(){document.removeEventListener("keyup",this.keyPress)}},function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("transition",{attrs:{name:t.transition}},[i("div",{directives:[{name:"show",rawName:"v-show",value:t.isActive,expression:"isActive"}],staticClass:"vld-overlay is-active",class:{"is-full-page":t.isFullPage},attrs:{tabindex:"0","aria-busy":t.isActive,"aria-label":"Loading"}},[i("div",{staticClass:"vld-background",style:{background:this.backgroundColor,opacity:this.opacity},on:{click:function(e){return e.preventDefault(),t.cancel(e)}}}),t._v(" "),i("div",{staticClass:"vld-icon"},[t._t("before"),t._v(" "),t._t("default",[i(t.loader,{tag:"component",attrs:{color:t.color,width:t.width,height:t.height}})]),t._v(" "),t._t("after")],2)])])},[],!1,null,null,null);f.options.__file="Component.vue";var p=f.exports,h=function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};return{show:function(){var n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:e,r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:i,a=Object.assign({},e,n,{programmatic:!0}),o=new(t.extend(p))({el:document.createElement("div"),propsData:a}),s=Object.assign({},i,r);return Object.keys(s).map(function(t){o.$slots[t]=s[t]}),o}}};i(0);p.install=function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},n=h(t,e,i);t.$loading=n,t.prototype.$loading=n};e.default=p}]).default});

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(125);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(64)("4a1fd46d", content, true, {});

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(98), __esModule: true };

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(99);
module.exports = __webpack_require__(12).Object.assign;


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(100);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(110) });


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(85);
var core = __webpack_require__(12);
var ctx = __webpack_require__(101);
var hide = __webpack_require__(103);
var has = __webpack_require__(89);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(102);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(104);
var createDesc = __webpack_require__(109);
module.exports = __webpack_require__(87) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(105);
var IE8_DOM_DEFINE = __webpack_require__(106);
var toPrimitive = __webpack_require__(108);
var dP = Object.defineProperty;

exports.f = __webpack_require__(87) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(86);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(87) && !__webpack_require__(88)(function () {
  return Object.defineProperty(__webpack_require__(107)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(86);
var document = __webpack_require__(85).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(86);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 109 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(111);
var gOPS = __webpack_require__(122);
var pIE = __webpack_require__(123);
var toObject = __webpack_require__(124);
var IObject = __webpack_require__(91);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(88)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(112);
var enumBugKeys = __webpack_require__(121);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(89);
var toIObject = __webpack_require__(90);
var arrayIndexOf = __webpack_require__(114)(false);
var IE_PROTO = __webpack_require__(117)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 113 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(90);
var toLength = __webpack_require__(115);
var toAbsoluteIndex = __webpack_require__(116);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(93);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(93);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(118)('keys');
var uid = __webpack_require__(120);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(12);
var global = __webpack_require__(85);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(119) ? 'pure' : 'global',
  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 119 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 120 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 121 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 122 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 123 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(92);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(63)(true);
// imports


// module
exports.push([module.i, ".vld-overlay{bottom:0;left:0;position:absolute;right:0;top:0;align-items:center;display:none;justify-content:center;overflow:hidden;z-index:1}.vld-overlay.is-active{display:flex}.vld-overlay.is-full-page{z-index:999;position:fixed}.vld-overlay .vld-background{bottom:0;left:0;position:absolute;right:0;top:0;background:#fff;opacity:.5}.vld-overlay .vld-icon,.vld-parent{position:relative}", "", {"version":3,"sources":["C:/Users/imkeeper/Desktop/Paybox/ui/C9/node_modules/vue-loading-overlay/dist/vue-loading.css"],"names":[],"mappings":"AAAA,aACE,SAAU,AACV,OAAQ,AACR,kBAAmB,AACnB,QAAS,AACT,MAAO,AACP,mBAAoB,AACpB,aAAc,AACd,uBAAwB,AACxB,gBAAiB,AACjB,SAAU,CACX,AAED,uBACE,YAAa,CACd,AAED,0BACE,YAAa,AACb,cAAe,CAChB,AAED,6BACE,SAAU,AACV,OAAQ,AACR,kBAAmB,AACnB,QAAS,AACT,MAAO,AACP,gBAAiB,AACjB,UAAY,CACb,AAMD,mCACE,iBAAkB,CACnB","file":"vue-loading.css","sourcesContent":[".vld-overlay {\n  bottom: 0;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  align-items: center;\n  display: none;\n  justify-content: center;\n  overflow: hidden;\n  z-index: 1\n}\n\n.vld-overlay.is-active {\n  display: flex\n}\n\n.vld-overlay.is-full-page {\n  z-index: 999;\n  position: fixed\n}\n\n.vld-overlay .vld-background {\n  bottom: 0;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  background: #fff;\n  opacity: 0.5\n}\n\n.vld-overlay .vld-icon {\n  position: relative\n}\n\n.vld-parent {\n  position: relative\n}\n\n\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 126 */,
/* 127 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 128 */,
/* 129 */,
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/wallet.62540ee.png";

/***/ }),
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/remoney.5693b02.png";

/***/ }),
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*!
 * qrcode.vue v1.6.1
 * A Vue component for QRCode.
 * © 2017-2018 @scopewu
 * MIT License.
 */
var mode = {
  MODE_NUMBER: 1 << 0,
  MODE_ALPHA_NUM: 1 << 1,
  MODE_8BIT_BYTE: 1 << 2,
  MODE_KANJI: 1 << 3
};

function QR8bitByte(data) {
  this.mode = mode.MODE_8BIT_BYTE;
  this.data = data;
}

QR8bitByte.prototype = {
  getLength: function (buffer) {
    return this.data.length;
  },
  write: function (buffer) {
    for (var i = 0; i < this.data.length; i++) {
      // not JIS ...
      buffer.put(this.data.charCodeAt(i), 8);
    }
  }
};
var _8BitByte = QR8bitByte;

var ErrorCorrectLevel = {
  L: 1,
  M: 0,
  Q: 3,
  H: 2
};

function QRRSBlock(totalCount, dataCount) {
  this.totalCount = totalCount;
  this.dataCount = dataCount;
}

QRRSBlock.RS_BLOCK_TABLE = [// L
// M
// Q
// H
// 1
[1, 26, 19], [1, 26, 16], [1, 26, 13], [1, 26, 9], // 2
[1, 44, 34], [1, 44, 28], [1, 44, 22], [1, 44, 16], // 3
[1, 70, 55], [1, 70, 44], [2, 35, 17], [2, 35, 13], // 4		
[1, 100, 80], [2, 50, 32], [2, 50, 24], [4, 25, 9], // 5
[1, 134, 108], [2, 67, 43], [2, 33, 15, 2, 34, 16], [2, 33, 11, 2, 34, 12], // 6
[2, 86, 68], [4, 43, 27], [4, 43, 19], [4, 43, 15], // 7		
[2, 98, 78], [4, 49, 31], [2, 32, 14, 4, 33, 15], [4, 39, 13, 1, 40, 14], // 8
[2, 121, 97], [2, 60, 38, 2, 61, 39], [4, 40, 18, 2, 41, 19], [4, 40, 14, 2, 41, 15], // 9
[2, 146, 116], [3, 58, 36, 2, 59, 37], [4, 36, 16, 4, 37, 17], [4, 36, 12, 4, 37, 13], // 10		
[2, 86, 68, 2, 87, 69], [4, 69, 43, 1, 70, 44], [6, 43, 19, 2, 44, 20], [6, 43, 15, 2, 44, 16], // 11
[4, 101, 81], [1, 80, 50, 4, 81, 51], [4, 50, 22, 4, 51, 23], [3, 36, 12, 8, 37, 13], // 12
[2, 116, 92, 2, 117, 93], [6, 58, 36, 2, 59, 37], [4, 46, 20, 6, 47, 21], [7, 42, 14, 4, 43, 15], // 13
[4, 133, 107], [8, 59, 37, 1, 60, 38], [8, 44, 20, 4, 45, 21], [12, 33, 11, 4, 34, 12], // 14
[3, 145, 115, 1, 146, 116], [4, 64, 40, 5, 65, 41], [11, 36, 16, 5, 37, 17], [11, 36, 12, 5, 37, 13], // 15
[5, 109, 87, 1, 110, 88], [5, 65, 41, 5, 66, 42], [5, 54, 24, 7, 55, 25], [11, 36, 12], // 16
[5, 122, 98, 1, 123, 99], [7, 73, 45, 3, 74, 46], [15, 43, 19, 2, 44, 20], [3, 45, 15, 13, 46, 16], // 17
[1, 135, 107, 5, 136, 108], [10, 74, 46, 1, 75, 47], [1, 50, 22, 15, 51, 23], [2, 42, 14, 17, 43, 15], // 18
[5, 150, 120, 1, 151, 121], [9, 69, 43, 4, 70, 44], [17, 50, 22, 1, 51, 23], [2, 42, 14, 19, 43, 15], // 19
[3, 141, 113, 4, 142, 114], [3, 70, 44, 11, 71, 45], [17, 47, 21, 4, 48, 22], [9, 39, 13, 16, 40, 14], // 20
[3, 135, 107, 5, 136, 108], [3, 67, 41, 13, 68, 42], [15, 54, 24, 5, 55, 25], [15, 43, 15, 10, 44, 16], // 21
[4, 144, 116, 4, 145, 117], [17, 68, 42], [17, 50, 22, 6, 51, 23], [19, 46, 16, 6, 47, 17], // 22
[2, 139, 111, 7, 140, 112], [17, 74, 46], [7, 54, 24, 16, 55, 25], [34, 37, 13], // 23
[4, 151, 121, 5, 152, 122], [4, 75, 47, 14, 76, 48], [11, 54, 24, 14, 55, 25], [16, 45, 15, 14, 46, 16], // 24
[6, 147, 117, 4, 148, 118], [6, 73, 45, 14, 74, 46], [11, 54, 24, 16, 55, 25], [30, 46, 16, 2, 47, 17], // 25
[8, 132, 106, 4, 133, 107], [8, 75, 47, 13, 76, 48], [7, 54, 24, 22, 55, 25], [22, 45, 15, 13, 46, 16], // 26
[10, 142, 114, 2, 143, 115], [19, 74, 46, 4, 75, 47], [28, 50, 22, 6, 51, 23], [33, 46, 16, 4, 47, 17], // 27
[8, 152, 122, 4, 153, 123], [22, 73, 45, 3, 74, 46], [8, 53, 23, 26, 54, 24], [12, 45, 15, 28, 46, 16], // 28
[3, 147, 117, 10, 148, 118], [3, 73, 45, 23, 74, 46], [4, 54, 24, 31, 55, 25], [11, 45, 15, 31, 46, 16], // 29
[7, 146, 116, 7, 147, 117], [21, 73, 45, 7, 74, 46], [1, 53, 23, 37, 54, 24], [19, 45, 15, 26, 46, 16], // 30
[5, 145, 115, 10, 146, 116], [19, 75, 47, 10, 76, 48], [15, 54, 24, 25, 55, 25], [23, 45, 15, 25, 46, 16], // 31
[13, 145, 115, 3, 146, 116], [2, 74, 46, 29, 75, 47], [42, 54, 24, 1, 55, 25], [23, 45, 15, 28, 46, 16], // 32
[17, 145, 115], [10, 74, 46, 23, 75, 47], [10, 54, 24, 35, 55, 25], [19, 45, 15, 35, 46, 16], // 33
[17, 145, 115, 1, 146, 116], [14, 74, 46, 21, 75, 47], [29, 54, 24, 19, 55, 25], [11, 45, 15, 46, 46, 16], // 34
[13, 145, 115, 6, 146, 116], [14, 74, 46, 23, 75, 47], [44, 54, 24, 7, 55, 25], [59, 46, 16, 1, 47, 17], // 35
[12, 151, 121, 7, 152, 122], [12, 75, 47, 26, 76, 48], [39, 54, 24, 14, 55, 25], [22, 45, 15, 41, 46, 16], // 36
[6, 151, 121, 14, 152, 122], [6, 75, 47, 34, 76, 48], [46, 54, 24, 10, 55, 25], [2, 45, 15, 64, 46, 16], // 37
[17, 152, 122, 4, 153, 123], [29, 74, 46, 14, 75, 47], [49, 54, 24, 10, 55, 25], [24, 45, 15, 46, 46, 16], // 38
[4, 152, 122, 18, 153, 123], [13, 74, 46, 32, 75, 47], [48, 54, 24, 14, 55, 25], [42, 45, 15, 32, 46, 16], // 39
[20, 147, 117, 4, 148, 118], [40, 75, 47, 7, 76, 48], [43, 54, 24, 22, 55, 25], [10, 45, 15, 67, 46, 16], // 40
[19, 148, 118, 6, 149, 119], [18, 75, 47, 31, 76, 48], [34, 54, 24, 34, 55, 25], [20, 45, 15, 61, 46, 16]];

QRRSBlock.getRSBlocks = function (typeNumber, errorCorrectLevel) {
  var rsBlock = QRRSBlock.getRsBlockTable(typeNumber, errorCorrectLevel);

  if (rsBlock == undefined) {
    throw new Error("bad rs block @ typeNumber:" + typeNumber + "/errorCorrectLevel:" + errorCorrectLevel);
  }

  var length = rsBlock.length / 3;
  var list = new Array();

  for (var i = 0; i < length; i++) {
    var count = rsBlock[i * 3 + 0];
    var totalCount = rsBlock[i * 3 + 1];
    var dataCount = rsBlock[i * 3 + 2];

    for (var j = 0; j < count; j++) {
      list.push(new QRRSBlock(totalCount, dataCount));
    }
  }

  return list;
};

QRRSBlock.getRsBlockTable = function (typeNumber, errorCorrectLevel) {
  switch (errorCorrectLevel) {
    case ErrorCorrectLevel.L:
      return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 0];

    case ErrorCorrectLevel.M:
      return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 1];

    case ErrorCorrectLevel.Q:
      return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 2];

    case ErrorCorrectLevel.H:
      return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 3];

    default:
      return undefined;
  }
};

var RSBlock = QRRSBlock;

function QRBitBuffer() {
  this.buffer = new Array();
  this.length = 0;
}

QRBitBuffer.prototype = {
  get: function (index) {
    var bufIndex = Math.floor(index / 8);
    return (this.buffer[bufIndex] >>> 7 - index % 8 & 1) == 1;
  },
  put: function (num, length) {
    for (var i = 0; i < length; i++) {
      this.putBit((num >>> length - i - 1 & 1) == 1);
    }
  },
  getLengthInBits: function () {
    return this.length;
  },
  putBit: function (bit) {
    var bufIndex = Math.floor(this.length / 8);

    if (this.buffer.length <= bufIndex) {
      this.buffer.push(0);
    }

    if (bit) {
      this.buffer[bufIndex] |= 0x80 >>> this.length % 8;
    }

    this.length++;
  }
};
var BitBuffer = QRBitBuffer;

var QRMath = {
  glog: function (n) {
    if (n < 1) {
      throw new Error("glog(" + n + ")");
    }

    return QRMath.LOG_TABLE[n];
  },
  gexp: function (n) {
    while (n < 0) {
      n += 255;
    }

    while (n >= 256) {
      n -= 255;
    }

    return QRMath.EXP_TABLE[n];
  },
  EXP_TABLE: new Array(256),
  LOG_TABLE: new Array(256)
};

for (var i = 0; i < 8; i++) {
  QRMath.EXP_TABLE[i] = 1 << i;
}

for (var i = 8; i < 256; i++) {
  QRMath.EXP_TABLE[i] = QRMath.EXP_TABLE[i - 4] ^ QRMath.EXP_TABLE[i - 5] ^ QRMath.EXP_TABLE[i - 6] ^ QRMath.EXP_TABLE[i - 8];
}

for (var i = 0; i < 255; i++) {
  QRMath.LOG_TABLE[QRMath.EXP_TABLE[i]] = i;
}

var math = QRMath;

function QRPolynomial(num, shift) {
  if (num.length == undefined) {
    throw new Error(num.length + "/" + shift);
  }

  var offset = 0;

  while (offset < num.length && num[offset] == 0) {
    offset++;
  }

  this.num = new Array(num.length - offset + shift);

  for (var i = 0; i < num.length - offset; i++) {
    this.num[i] = num[i + offset];
  }
}

QRPolynomial.prototype = {
  get: function (index) {
    return this.num[index];
  },
  getLength: function () {
    return this.num.length;
  },
  multiply: function (e) {
    var num = new Array(this.getLength() + e.getLength() - 1);

    for (var i = 0; i < this.getLength(); i++) {
      for (var j = 0; j < e.getLength(); j++) {
        num[i + j] ^= math.gexp(math.glog(this.get(i)) + math.glog(e.get(j)));
      }
    }

    return new QRPolynomial(num, 0);
  },
  mod: function (e) {
    if (this.getLength() - e.getLength() < 0) {
      return this;
    }

    var ratio = math.glog(this.get(0)) - math.glog(e.get(0));
    var num = new Array(this.getLength());

    for (var i = 0; i < this.getLength(); i++) {
      num[i] = this.get(i);
    }

    for (var i = 0; i < e.getLength(); i++) {
      num[i] ^= math.gexp(math.glog(e.get(i)) + ratio);
    } // recursive call


    return new QRPolynomial(num, 0).mod(e);
  }
};
var Polynomial = QRPolynomial;

var QRMaskPattern = {
  PATTERN000: 0,
  PATTERN001: 1,
  PATTERN010: 2,
  PATTERN011: 3,
  PATTERN100: 4,
  PATTERN101: 5,
  PATTERN110: 6,
  PATTERN111: 7
};
var QRUtil = {
  PATTERN_POSITION_TABLE: [[], [6, 18], [6, 22], [6, 26], [6, 30], [6, 34], [6, 22, 38], [6, 24, 42], [6, 26, 46], [6, 28, 50], [6, 30, 54], [6, 32, 58], [6, 34, 62], [6, 26, 46, 66], [6, 26, 48, 70], [6, 26, 50, 74], [6, 30, 54, 78], [6, 30, 56, 82], [6, 30, 58, 86], [6, 34, 62, 90], [6, 28, 50, 72, 94], [6, 26, 50, 74, 98], [6, 30, 54, 78, 102], [6, 28, 54, 80, 106], [6, 32, 58, 84, 110], [6, 30, 58, 86, 114], [6, 34, 62, 90, 118], [6, 26, 50, 74, 98, 122], [6, 30, 54, 78, 102, 126], [6, 26, 52, 78, 104, 130], [6, 30, 56, 82, 108, 134], [6, 34, 60, 86, 112, 138], [6, 30, 58, 86, 114, 142], [6, 34, 62, 90, 118, 146], [6, 30, 54, 78, 102, 126, 150], [6, 24, 50, 76, 102, 128, 154], [6, 28, 54, 80, 106, 132, 158], [6, 32, 58, 84, 110, 136, 162], [6, 26, 54, 82, 110, 138, 166], [6, 30, 58, 86, 114, 142, 170]],
  G15: 1 << 10 | 1 << 8 | 1 << 5 | 1 << 4 | 1 << 2 | 1 << 1 | 1 << 0,
  G18: 1 << 12 | 1 << 11 | 1 << 10 | 1 << 9 | 1 << 8 | 1 << 5 | 1 << 2 | 1 << 0,
  G15_MASK: 1 << 14 | 1 << 12 | 1 << 10 | 1 << 4 | 1 << 1,
  getBCHTypeInfo: function (data) {
    var d = data << 10;

    while (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G15) >= 0) {
      d ^= QRUtil.G15 << QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G15);
    }

    return (data << 10 | d) ^ QRUtil.G15_MASK;
  },
  getBCHTypeNumber: function (data) {
    var d = data << 12;

    while (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G18) >= 0) {
      d ^= QRUtil.G18 << QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G18);
    }

    return data << 12 | d;
  },
  getBCHDigit: function (data) {
    var digit = 0;

    while (data != 0) {
      digit++;
      data >>>= 1;
    }

    return digit;
  },
  getPatternPosition: function (typeNumber) {
    return QRUtil.PATTERN_POSITION_TABLE[typeNumber - 1];
  },
  getMask: function (maskPattern, i, j) {
    switch (maskPattern) {
      case QRMaskPattern.PATTERN000:
        return (i + j) % 2 == 0;

      case QRMaskPattern.PATTERN001:
        return i % 2 == 0;

      case QRMaskPattern.PATTERN010:
        return j % 3 == 0;

      case QRMaskPattern.PATTERN011:
        return (i + j) % 3 == 0;

      case QRMaskPattern.PATTERN100:
        return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 == 0;

      case QRMaskPattern.PATTERN101:
        return i * j % 2 + i * j % 3 == 0;

      case QRMaskPattern.PATTERN110:
        return (i * j % 2 + i * j % 3) % 2 == 0;

      case QRMaskPattern.PATTERN111:
        return (i * j % 3 + (i + j) % 2) % 2 == 0;

      default:
        throw new Error("bad maskPattern:" + maskPattern);
    }
  },
  getErrorCorrectPolynomial: function (errorCorrectLength) {
    var a = new Polynomial([1], 0);

    for (var i = 0; i < errorCorrectLength; i++) {
      a = a.multiply(new Polynomial([1, math.gexp(i)], 0));
    }

    return a;
  },
  getLengthInBits: function (mode$$1, type) {
    if (1 <= type && type < 10) {
      // 1 - 9
      switch (mode$$1) {
        case mode.MODE_NUMBER:
          return 10;

        case mode.MODE_ALPHA_NUM:
          return 9;

        case mode.MODE_8BIT_BYTE:
          return 8;

        case mode.MODE_KANJI:
          return 8;

        default:
          throw new Error("mode:" + mode$$1);
      }
    } else if (type < 27) {
      // 10 - 26
      switch (mode$$1) {
        case mode.MODE_NUMBER:
          return 12;

        case mode.MODE_ALPHA_NUM:
          return 11;

        case mode.MODE_8BIT_BYTE:
          return 16;

        case mode.MODE_KANJI:
          return 10;

        default:
          throw new Error("mode:" + mode$$1);
      }
    } else if (type < 41) {
      // 27 - 40
      switch (mode$$1) {
        case mode.MODE_NUMBER:
          return 14;

        case mode.MODE_ALPHA_NUM:
          return 13;

        case mode.MODE_8BIT_BYTE:
          return 16;

        case mode.MODE_KANJI:
          return 12;

        default:
          throw new Error("mode:" + mode$$1);
      }
    } else {
      throw new Error("type:" + type);
    }
  },
  getLostPoint: function (qrCode) {
    var moduleCount = qrCode.getModuleCount();
    var lostPoint = 0; // LEVEL1

    for (var row = 0; row < moduleCount; row++) {
      for (var col = 0; col < moduleCount; col++) {
        var sameCount = 0;
        var dark = qrCode.isDark(row, col);

        for (var r = -1; r <= 1; r++) {
          if (row + r < 0 || moduleCount <= row + r) {
            continue;
          }

          for (var c = -1; c <= 1; c++) {
            if (col + c < 0 || moduleCount <= col + c) {
              continue;
            }

            if (r == 0 && c == 0) {
              continue;
            }

            if (dark == qrCode.isDark(row + r, col + c)) {
              sameCount++;
            }
          }
        }

        if (sameCount > 5) {
          lostPoint += 3 + sameCount - 5;
        }
      }
    } // LEVEL2


    for (var row = 0; row < moduleCount - 1; row++) {
      for (var col = 0; col < moduleCount - 1; col++) {
        var count = 0;
        if (qrCode.isDark(row, col)) count++;
        if (qrCode.isDark(row + 1, col)) count++;
        if (qrCode.isDark(row, col + 1)) count++;
        if (qrCode.isDark(row + 1, col + 1)) count++;

        if (count == 0 || count == 4) {
          lostPoint += 3;
        }
      }
    } // LEVEL3


    for (var row = 0; row < moduleCount; row++) {
      for (var col = 0; col < moduleCount - 6; col++) {
        if (qrCode.isDark(row, col) && !qrCode.isDark(row, col + 1) && qrCode.isDark(row, col + 2) && qrCode.isDark(row, col + 3) && qrCode.isDark(row, col + 4) && !qrCode.isDark(row, col + 5) && qrCode.isDark(row, col + 6)) {
          lostPoint += 40;
        }
      }
    }

    for (var col = 0; col < moduleCount; col++) {
      for (var row = 0; row < moduleCount - 6; row++) {
        if (qrCode.isDark(row, col) && !qrCode.isDark(row + 1, col) && qrCode.isDark(row + 2, col) && qrCode.isDark(row + 3, col) && qrCode.isDark(row + 4, col) && !qrCode.isDark(row + 5, col) && qrCode.isDark(row + 6, col)) {
          lostPoint += 40;
        }
      }
    } // LEVEL4


    var darkCount = 0;

    for (var col = 0; col < moduleCount; col++) {
      for (var row = 0; row < moduleCount; row++) {
        if (qrCode.isDark(row, col)) {
          darkCount++;
        }
      }
    }

    var ratio = Math.abs(100 * darkCount / moduleCount / moduleCount - 50) / 5;
    lostPoint += ratio * 10;
    return lostPoint;
  }
};
var util = QRUtil;

function QRCode(typeNumber, errorCorrectLevel) {
  this.typeNumber = typeNumber;
  this.errorCorrectLevel = errorCorrectLevel;
  this.modules = null;
  this.moduleCount = 0;
  this.dataCache = null;
  this.dataList = [];
} // for client side minification


var proto = QRCode.prototype;

proto.addData = function (data) {
  var newData = new _8BitByte(data);
  this.dataList.push(newData);
  this.dataCache = null;
};

proto.isDark = function (row, col) {
  if (row < 0 || this.moduleCount <= row || col < 0 || this.moduleCount <= col) {
    throw new Error(row + "," + col);
  }

  return this.modules[row][col];
};

proto.getModuleCount = function () {
  return this.moduleCount;
};

proto.make = function () {
  // Calculate automatically typeNumber if provided is < 1
  if (this.typeNumber < 1) {
    var typeNumber = 1;

    for (typeNumber = 1; typeNumber < 40; typeNumber++) {
      var rsBlocks = RSBlock.getRSBlocks(typeNumber, this.errorCorrectLevel);
      var buffer = new BitBuffer();
      var totalDataCount = 0;

      for (var i = 0; i < rsBlocks.length; i++) {
        totalDataCount += rsBlocks[i].dataCount;
      }

      for (var i = 0; i < this.dataList.length; i++) {
        var data = this.dataList[i];
        buffer.put(data.mode, 4);
        buffer.put(data.getLength(), util.getLengthInBits(data.mode, typeNumber));
        data.write(buffer);
      }

      if (buffer.getLengthInBits() <= totalDataCount * 8) break;
    }

    this.typeNumber = typeNumber;
  }

  this.makeImpl(false, this.getBestMaskPattern());
};

proto.makeImpl = function (test, maskPattern) {
  this.moduleCount = this.typeNumber * 4 + 17;
  this.modules = new Array(this.moduleCount);

  for (var row = 0; row < this.moduleCount; row++) {
    this.modules[row] = new Array(this.moduleCount);

    for (var col = 0; col < this.moduleCount; col++) {
      this.modules[row][col] = null; //(col + row) % 3;
    }
  }

  this.setupPositionProbePattern(0, 0);
  this.setupPositionProbePattern(this.moduleCount - 7, 0);
  this.setupPositionProbePattern(0, this.moduleCount - 7);
  this.setupPositionAdjustPattern();
  this.setupTimingPattern();
  this.setupTypeInfo(test, maskPattern);

  if (this.typeNumber >= 7) {
    this.setupTypeNumber(test);
  }

  if (this.dataCache == null) {
    this.dataCache = QRCode.createData(this.typeNumber, this.errorCorrectLevel, this.dataList);
  }

  this.mapData(this.dataCache, maskPattern);
};

proto.setupPositionProbePattern = function (row, col) {
  for (var r = -1; r <= 7; r++) {
    if (row + r <= -1 || this.moduleCount <= row + r) continue;

    for (var c = -1; c <= 7; c++) {
      if (col + c <= -1 || this.moduleCount <= col + c) continue;

      if (0 <= r && r <= 6 && (c == 0 || c == 6) || 0 <= c && c <= 6 && (r == 0 || r == 6) || 2 <= r && r <= 4 && 2 <= c && c <= 4) {
        this.modules[row + r][col + c] = true;
      } else {
        this.modules[row + r][col + c] = false;
      }
    }
  }
};

proto.getBestMaskPattern = function () {
  var minLostPoint = 0;
  var pattern = 0;

  for (var i = 0; i < 8; i++) {
    this.makeImpl(true, i);
    var lostPoint = util.getLostPoint(this);

    if (i == 0 || minLostPoint > lostPoint) {
      minLostPoint = lostPoint;
      pattern = i;
    }
  }

  return pattern;
};

proto.createMovieClip = function (target_mc, instance_name, depth) {
  var qr_mc = target_mc.createEmptyMovieClip(instance_name, depth);
  var cs = 1;
  this.make();

  for (var row = 0; row < this.modules.length; row++) {
    var y = row * cs;

    for (var col = 0; col < this.modules[row].length; col++) {
      var x = col * cs;
      var dark = this.modules[row][col];

      if (dark) {
        qr_mc.beginFill(0, 100);
        qr_mc.moveTo(x, y);
        qr_mc.lineTo(x + cs, y);
        qr_mc.lineTo(x + cs, y + cs);
        qr_mc.lineTo(x, y + cs);
        qr_mc.endFill();
      }
    }
  }

  return qr_mc;
};

proto.setupTimingPattern = function () {
  for (var r = 8; r < this.moduleCount - 8; r++) {
    if (this.modules[r][6] != null) {
      continue;
    }

    this.modules[r][6] = r % 2 == 0;
  }

  for (var c = 8; c < this.moduleCount - 8; c++) {
    if (this.modules[6][c] != null) {
      continue;
    }

    this.modules[6][c] = c % 2 == 0;
  }
};

proto.setupPositionAdjustPattern = function () {
  var pos = util.getPatternPosition(this.typeNumber);

  for (var i = 0; i < pos.length; i++) {
    for (var j = 0; j < pos.length; j++) {
      var row = pos[i];
      var col = pos[j];

      if (this.modules[row][col] != null) {
        continue;
      }

      for (var r = -2; r <= 2; r++) {
        for (var c = -2; c <= 2; c++) {
          if (r == -2 || r == 2 || c == -2 || c == 2 || r == 0 && c == 0) {
            this.modules[row + r][col + c] = true;
          } else {
            this.modules[row + r][col + c] = false;
          }
        }
      }
    }
  }
};

proto.setupTypeNumber = function (test) {
  var bits = util.getBCHTypeNumber(this.typeNumber);

  for (var i = 0; i < 18; i++) {
    var mod = !test && (bits >> i & 1) == 1;
    this.modules[Math.floor(i / 3)][i % 3 + this.moduleCount - 8 - 3] = mod;
  }

  for (var i = 0; i < 18; i++) {
    var mod = !test && (bits >> i & 1) == 1;
    this.modules[i % 3 + this.moduleCount - 8 - 3][Math.floor(i / 3)] = mod;
  }
};

proto.setupTypeInfo = function (test, maskPattern) {
  var data = this.errorCorrectLevel << 3 | maskPattern;
  var bits = util.getBCHTypeInfo(data); // vertical		

  for (var i = 0; i < 15; i++) {
    var mod = !test && (bits >> i & 1) == 1;

    if (i < 6) {
      this.modules[i][8] = mod;
    } else if (i < 8) {
      this.modules[i + 1][8] = mod;
    } else {
      this.modules[this.moduleCount - 15 + i][8] = mod;
    }
  } // horizontal


  for (var i = 0; i < 15; i++) {
    var mod = !test && (bits >> i & 1) == 1;

    if (i < 8) {
      this.modules[8][this.moduleCount - i - 1] = mod;
    } else if (i < 9) {
      this.modules[8][15 - i - 1 + 1] = mod;
    } else {
      this.modules[8][15 - i - 1] = mod;
    }
  } // fixed module


  this.modules[this.moduleCount - 8][8] = !test;
};

proto.mapData = function (data, maskPattern) {
  var inc = -1;
  var row = this.moduleCount - 1;
  var bitIndex = 7;
  var byteIndex = 0;

  for (var col = this.moduleCount - 1; col > 0; col -= 2) {
    if (col == 6) col--;

    while (true) {
      for (var c = 0; c < 2; c++) {
        if (this.modules[row][col - c] == null) {
          var dark = false;

          if (byteIndex < data.length) {
            dark = (data[byteIndex] >>> bitIndex & 1) == 1;
          }

          var mask = util.getMask(maskPattern, row, col - c);

          if (mask) {
            dark = !dark;
          }

          this.modules[row][col - c] = dark;
          bitIndex--;

          if (bitIndex == -1) {
            byteIndex++;
            bitIndex = 7;
          }
        }
      }

      row += inc;

      if (row < 0 || this.moduleCount <= row) {
        row -= inc;
        inc = -inc;
        break;
      }
    }
  }
};

QRCode.PAD0 = 0xEC;
QRCode.PAD1 = 0x11;

QRCode.createData = function (typeNumber, errorCorrectLevel, dataList) {
  var rsBlocks = RSBlock.getRSBlocks(typeNumber, errorCorrectLevel);
  var buffer = new BitBuffer();

  for (var i = 0; i < dataList.length; i++) {
    var data = dataList[i];
    buffer.put(data.mode, 4);
    buffer.put(data.getLength(), util.getLengthInBits(data.mode, typeNumber));
    data.write(buffer);
  } // calc num max data.


  var totalDataCount = 0;

  for (var i = 0; i < rsBlocks.length; i++) {
    totalDataCount += rsBlocks[i].dataCount;
  }

  if (buffer.getLengthInBits() > totalDataCount * 8) {
    throw new Error("code length overflow. (" + buffer.getLengthInBits() + ">" + totalDataCount * 8 + ")");
  } // end code


  if (buffer.getLengthInBits() + 4 <= totalDataCount * 8) {
    buffer.put(0, 4);
  } // padding


  while (buffer.getLengthInBits() % 8 != 0) {
    buffer.putBit(false);
  } // padding


  while (true) {
    if (buffer.getLengthInBits() >= totalDataCount * 8) {
      break;
    }

    buffer.put(QRCode.PAD0, 8);

    if (buffer.getLengthInBits() >= totalDataCount * 8) {
      break;
    }

    buffer.put(QRCode.PAD1, 8);
  }

  return QRCode.createBytes(buffer, rsBlocks);
};

QRCode.createBytes = function (buffer, rsBlocks) {
  var offset = 0;
  var maxDcCount = 0;
  var maxEcCount = 0;
  var dcdata = new Array(rsBlocks.length);
  var ecdata = new Array(rsBlocks.length);

  for (var r = 0; r < rsBlocks.length; r++) {
    var dcCount = rsBlocks[r].dataCount;
    var ecCount = rsBlocks[r].totalCount - dcCount;
    maxDcCount = Math.max(maxDcCount, dcCount);
    maxEcCount = Math.max(maxEcCount, ecCount);
    dcdata[r] = new Array(dcCount);

    for (var i = 0; i < dcdata[r].length; i++) {
      dcdata[r][i] = 0xff & buffer.buffer[i + offset];
    }

    offset += dcCount;
    var rsPoly = util.getErrorCorrectPolynomial(ecCount);
    var rawPoly = new Polynomial(dcdata[r], rsPoly.getLength() - 1);
    var modPoly = rawPoly.mod(rsPoly);
    ecdata[r] = new Array(rsPoly.getLength() - 1);

    for (var i = 0; i < ecdata[r].length; i++) {
      var modIndex = i + modPoly.getLength() - ecdata[r].length;
      ecdata[r][i] = modIndex >= 0 ? modPoly.get(modIndex) : 0;
    }
  }

  var totalCodeCount = 0;

  for (var i = 0; i < rsBlocks.length; i++) {
    totalCodeCount += rsBlocks[i].totalCount;
  }

  var data = new Array(totalCodeCount);
  var index = 0;

  for (var i = 0; i < maxDcCount; i++) {
    for (var r = 0; r < rsBlocks.length; r++) {
      if (i < dcdata[r].length) {
        data[index++] = dcdata[r][i];
      }
    }
  }

  for (var i = 0; i < maxEcCount; i++) {
    for (var r = 0; r < rsBlocks.length; r++) {
      if (i < ecdata[r].length) {
        data[index++] = ecdata[r][i];
      }
    }
  }

  return data;
};

var QRCode_1 = QRCode;

function getBackingStorePixelRatio(ctx) {
  return ctx.webkitBackingStorePixelRatio || ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio || ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1;
}
/**
 * Encode UTF16 to UTF8.
 * See: http://jonisalonen.com/2012/from-utf-16-to-utf-8-in-javascript/
 * @param str {string}
 * @returns {string}
 */


function toUTF8String(str) {
  var utf8Str = '';

  for (var i = 0; i < str.length; i++) {
    var charCode = str.charCodeAt(i);

    if (charCode < 0x0080) {
      utf8Str += String.fromCharCode(charCode);
    } else if (charCode < 0x0800) {
      utf8Str += String.fromCharCode(0xc0 | charCode >> 6);
      utf8Str += String.fromCharCode(0x80 | charCode & 0x3f);
    } else if (charCode < 0xd800 || charCode >= 0xe000) {
      utf8Str += String.fromCharCode(0xe0 | charCode >> 12);
      utf8Str += String.fromCharCode(0x80 | charCode >> 6 & 0x3f);
      utf8Str += String.fromCharCode(0x80 | charCode & 0x3f);
    } else {
      // surrogate pair
      i++; // UTF-16 encodes 0x10000-0x10FFFF by
      // subtracting 0x10000 and splitting the
      // 20 bits of 0x0-0xFFFFF into two halves

      charCode = 0x10000 + ((charCode & 0x3ff) << 10 | str.charCodeAt(i) & 0x3ff);
      utf8Str += String.fromCharCode(0xf0 | charCode >> 18);
      utf8Str += String.fromCharCode(0x80 | charCode >> 12 & 0x3f);
      utf8Str += String.fromCharCode(0x80 | charCode >> 6 & 0x3f);
      utf8Str += String.fromCharCode(0x80 | charCode & 0x3f);
    }
  }

  return utf8Str;
}

var QrcodeVue = {
  render: function render(createElement) {
    var className = this.className,
        value = this.value,
        level = this.level,
        background = this.background,
        foreground = this.foreground,
        size = this.size;
    return createElement('div', {
      'class': className,
      attrs: {
        value: value,
        level: level,
        background: background,
        foreground: foreground
      }
    }, [createElement('canvas', {
      attrs: {
        height: size,
        width: size
      },
      style: {
        width: size + 'px',
        height: size + 'px'
      },
      ref: 'qrcode-vue'
    }, [])]);
  },
  props: {
    value: {
      type: String,
      required: true,
      default: ''
    },
    className: {
      type: String,
      default: ''
    },
    size: {
      type: [Number, String],
      default: 100,
      validator: function validator(s) {
        return isNaN(Number(s)) !== true;
      }
    },
    level: {
      type: String,
      default: 'L',
      validator: function validator(l) {
        return ['L', 'Q', 'M', 'H'].indexOf(l) > -1;
      }
    },
    background: {
      type: String,
      default: '#fff'
    },
    foreground: {
      type: String,
      default: '#000'
    }
  },
  methods: {
    render: function render() {
      var value = this.value,
          size = this.size,
          level = this.level,
          background = this.background,
          foreground = this.foreground;

      var _size = size >>> 0; // size to number
      // We'll use type===-1 to force QRCode to automatically pick the best type


      var qrCode = new QRCode_1(-1, ErrorCorrectLevel[level]);
      qrCode.addData(toUTF8String(value));
      qrCode.make();
      var canvas = this.$refs['qrcode-vue'];
      var ctx = canvas.getContext('2d');
      var cells = qrCode.modules;
      var tileW = _size / cells.length;
      var tileH = _size / cells.length;
      var scale = (window.devicePixelRatio || 1) / getBackingStorePixelRatio(ctx);
      canvas.height = canvas.width = _size * scale;
      ctx.scale(scale, scale);
      cells.forEach(function (row, rdx) {
        row.forEach(function (cell, cdx) {
          ctx.fillStyle = cell ? foreground : background;
          var w = Math.ceil((cdx + 1) * tileW) - Math.floor(cdx * tileW);
          var h = Math.ceil((rdx + 1) * tileH) - Math.floor(rdx * tileH);
          ctx.fillRect(Math.round(cdx * tileW), Math.round(rdx * tileH), w, h);
        });
      });
    }
  },
  updated: function updated() {
    this.render();
  },
  mounted: function mounted() {
    this.render();
  }
};

/* harmony default export */ __webpack_exports__["a"] = (QrcodeVue);


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/promptpay.7037601.png";

/***/ }),
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_payment_TypeCach__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_payment_TypePromptpay__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_payment_TypeWallet__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_payment_TypeCredit__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_modal_refundpad__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_loading_overlay_dist_vue_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__service_services__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_sweetalert2__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_sweetalert2__);













/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay___default.a,
    Typecash: __WEBPACK_IMPORTED_MODULE_2__components_payment_TypeCach__["a" /* default */],
    Typepromptpay: __WEBPACK_IMPORTED_MODULE_3__components_payment_TypePromptpay__["a" /* default */],
    Typewallet: __WEBPACK_IMPORTED_MODULE_4__components_payment_TypeWallet__["a" /* default */],
    Typecredit: __WEBPACK_IMPORTED_MODULE_5__components_payment_TypeCredit__["a" /* default */],
    RefurdPad: __WEBPACK_IMPORTED_MODULE_6__components_modal_refundpad__["a" /* default */]
  },
  data: function data() {
    return {
      steppull: 0,
      title: 'เมนู',
      qrcode: '',
      itemImage: __webpack_require__(246),
      orderName: 'Select Item',
      step: 0,
      channel: null,
      chceck_genqr: 0,
      saleTypeText: '',
      t: '',
      sp: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])(['lang', 'AmountPayment', 'UUID', 'txn_id', 'accessToken', 'PaymentType', 'IDWallet', 'SaleID', 'sale_subs', 'page_status', 'config']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapMutations */])(['onMessageWs', 'clearState'])),
  methods: {
    back: function back() {
      var _this = this;

      this.Soundclick();
      clearInterval(this.t);
      this.$store.commit('clearPulling');
      this.$store.state.timeOut = 120;
      if (this.$store.state.AmountPayment > 0) {
        $('#Refurd').modal({ backdrop: "static" });
      } else {
        this.$socket.sendObj({
          command: 'receive_close'
        });
        this.$socket.sendObj({
          command: 'edc_cancel'
        });

        if (this.$store.state.page_status == 1) {
          this.$router.push({
            name: 'Main'
          });
          this.$store.state.page_status = 0;
          return;
        }
        if (this.$store.state.page_status == 2) {
          this.$router.push({
            name: 'shopping'
          });
          this.$store.state.page_status = 0;
          setTimeout(function () {
            _this.$store.state.isLoading;
          }, 2000);
          return;
        }
        this.$router.go(-1);
      }
    },
    deleyTime: function deleyTime() {
      var _this2 = this;

      this.t = setInterval(function () {
        _this2.checkAmount();
        if (_this2.$store.state.timeOut > 0) {
          _this2.$store.state.timeOut--;
        } else {
          clearInterval(_this2.t);
          if (_this2.$store.state.AmountPayment > 0) {
            __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default.a.fire({
              title: 'TimeOut',
              text: "ต้องการชำระเงินต่อไปหรือไม่",
              type: "warning",
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              confirmButtonText: 'OK !'
            }).then(function (result) {
              if (result.value) {
                _this2.$store.state.timeOut = 120;
                _this2.steppull = 0;
                _this2.$socket.sendObj({
                  command: 'receive_open'
                });
                _this2.deleyTime();
              } else {
                _this2.back();
              }
            });
          } else {
            _this2.back();
          }
        }
      }, 1000);
    },
    checkSaleType: function checkSaleType() {
      switch (this.$store.state.SaleID) {
        case 1:
          this.saleTypeText = 'Deposit';
          if (this.$store.state.sale_subs[0].image) {
            this.itemImage = this.$store.state.sale_subs[0].image;
          }
          break;
        case 2:
          this.saleTypeText = 'shopping';
          break;
        case 3:
          this.saleTypeText = 'SCAN QRCODE';
          break;
        case 4:
          this.saleTypeText = 'Quick Pay';
          if (this.$store.state.sale_subs[0].image) {
            this.itemImage = this.$store.state.sale_subs[0].image;
          }
          break;
        case 5:
          this.saleTypeText = 'Mobile app payment';
          if (this.$store.state.sale_subs[0].image) {
            this.itemImage = this.$store.state.sale_subs[0].image;
          }
          break;
        case 6:
          this.saleTypeText = 'Member Shop';
          break;
      }
      this.openSale();
    },
    openSale: function openSale() {
      var _this3 = this;

      var header = {
        headers: {
          'x-access-token': this.$store.state.accessToken
        }
      };
      __WEBPACK_IMPORTED_MODULE_9__service_services__["a" /* default */].openSale(header, function (result) {
        _this3.$store.state.txn_id = result.txn_id;
        _this3.$store.state.sale_info = result.info;
        _this3.deleyTime();
      }, function (error) {});
    },
    checkAmount: function checkAmount() {
      var _this4 = this;

      if (this.$store.state.AmountPayment == this.$store.state.total && this.$store.state.memberProfile != null) {
        clearInterval(this.t);
        this.$socket.sendObj({
          command: 'receive_close'
        });
        this.$socket.sendObj({
          command: 'edc_cancel'
        });

        if (this.$store.state.memberProfile.phone_number.substring(0, 3) == "+66") {
          var str = this.$store.state.memberProfile.phone_number;
          var cutBack = str.substring(3, 12);
          var phone_number = "0" + cutBack;
        } else {
          var phone_number = this.$store.state.memberProfile.phone_number;
        }

        this.$store.state.IDWallet = phone_number;
        $('#Refurd').modal('hide');
        switch (this.$store.state.PaymentType) {
          case 1:
            this.$router.push('/processcash');
            break;
          case 2:
            this.$router.push('/processcredit');
            break;
          case 3:
            this.$router.push('/processpromptpay');
            break;
          case 4:
            this.$router.push('/processwallet');
            break;
        }
      } else {
        if (this.$store.state.AmountPayment == this.$store.state.total && this.$store.state.SaleID != 1) {
          clearInterval(this.t);
          this.$socket.sendObj({
            command: 'receive_close'
          });
          this.$socket.sendObj({
            command: 'edc_cancel'
          });
          this.$store.state.IDWallet = '0894297335';
          $('#Refurd').modal('hide');
          switch (this.$store.state.PaymentType) {
            case 1:
              this.$router.push('/processcash');
              break;
            case 2:
              this.$router.push('/processcredit');
              break;
            case 3:
              this.$router.push('/processpromptpay');
              break;
            case 4:
              this.$router.push('/processwallet');
              break;
          }
          return;
        }
        // if(this.$store.state.PaymentType == 2){
        //   clearInterval(this.t)
        //   this.$store.commit('clearPulling')
        //   this.$store.state.AmountPayment = this.$store.state.total
        //   this.$socket.sendObj({
        //     command: 'receive_close'
        //   })
        //   $('#Refurd').modal('show')
        // }
        if (this.$store.state.PaymentType == 3 || this.$store.state.PaymentType == 4 || this.$store.state.PaymentType == 2 && this.$store.state.SaleID != 1) {
          clearInterval(this.t);
          this.$store.commit('clearPulling');
          // this.$store.state.AmountPayment = this.$store.state.total
          this.$socket.sendObj({
            command: 'receive_close'
          });
          this.$socket.sendObj({
            command: 'edc_cancel'
          });
          if (this.$store.state.memberProfile != null) {
            if (this.$store.state.memberProfile.phone_number.substring(0, 3) == "+66") {
              var str = this.$store.state.memberProfile.phone_number;
              var cutBack = str.substring(3, 12);
              var phone_number = "0" + cutBack;
            } else {
              var phone_number = this.$store.state.memberProfile.phone_number;
            }

            this.$store.state.IDWallet = phone_number;
            $('#Refurd').modal('hide');
            this.sp = setInterval(function () {
              if (_this4.steppull == 1) {
                clearInterval(_this4.sp);
                _this4.steppull = 0;
                switch (_this4.$store.state.PaymentType) {
                  case 2:
                    _this4.$router.push('/processcredit');

                    break;
                  case 3:
                    _this4.$router.push('/processpromptpay');

                    break;
                  case 4:
                    _this4.$router.push('/processwallet');

                    break;
                }
              }
            });
            return;
          } else {
            $('#Refurd').modal('show');
            return;
          }
        } else if (this.$store.state.AmountPayment >= this.$store.state.total || this.$store.state.PaymentType == 2) {
          if (this.$store.state.IDWallet != '' && this.$store.state.IDWallet != null) {
            clearInterval(this.t);
            this.$socket.sendObj({ command: 'receive_close' });
            if (this.$store.state.PaymentType == 2) {
              this.$store.state.AmountPayment = this.$store.state.total;
              this.$router.push('/processcredit');
            } else {
              this.$socket.sendObj({ command: 'edc_cancel' });
              switch (this.$store.state.PaymentType) {
                case 1:
                  this.$router.push('/processcash');
                  break;
                case 3:
                  this.$router.push('/processpromptpay');
                  break;
                case 4:
                  this.$router.push('/processwallet');
                  break;
              }
            }
          } else {
            $('#Refurd').modal({ backdrop: "static" });
            this.$store.commit('clearPulling');
            if ($('#Refurd').is(':visible')) {
              clearInterval(this.t);
              this.$socket.sendObj({
                command: 'receive_close'
              });
              this.$socket.sendObj({
                command: 'edc_cancel'
              });
            }
          }
        }
      }
    },
    websocket_onmessage: function websocket_onmessage() {
      var _this5 = this;

      this.$socket.onmessage = function (skResult) {
        _this5.$store.commit('onMessageWs', JSON.parse(skResult.data));
        var data = JSON.parse(skResult.data);

        if (data.command == "receive_close") {
          if (data.result == true) {
            _this5.steppull = 1;
          }
        }
      };
    }
  },
  mounted: function mounted() {
    this.$store.state.isLoading = true;
    this.websocket_onmessage();
    this.checkSaleType();
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)))

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['time', 'saleTypeText'],
  data: function data() {
    return {
      cash: {
        sku_id: 1,
        image_name: "money",
        color: "badge-primary",
        goto: "Cash",
        image_path: __webpack_require__(136),
        title_name: [{
          name_id: 0,
          name: "Cash",
          say: "Payment by cash"
        }, {
          name_id: 1,
          name: "เงินสด",
          say: "ชำระเงินโดย เงินสด"
        }, {
          name_id: 2,
          name: "现金",
          say: "通過現金付款"
        }]
      }
    };
  },

  methods: {
    checkTime: function checkTime() {
      var _this = this;

      this.$store.state.loopCash = setInterval(function () {
        if (_this.time == 0) {
          if (_this.$store.state.AmountPayment >= _this.$store.state.total) {} else {
            // this.$socket.sendObj({
            //   command: 'receive_close'
            // })
            clearInterval(_this.$store.state.loopCash);
          }
        }
      }, 1000);
    },
    ReceiveMoney: function ReceiveMoney() {
      var _this2 = this;

      try {
        this.$socket.sendObj({
          command: 'receive_open'
        });

        this.$store.state.isLoading = true;
        setTimeout(function () {
          if (_this2.$store.state.isLoading === true) {
            // this.$socket.sendObj({
            //   command: 'receive_close'
            // })
            _this2.$store.state.isLoading = false;
            // alert('ระบบรับเงินมีปัญหา กรุณาทำรายการใหม่')
            // this.$router.go(-1)
            // this.$store.state.timeOut = 0
          }
        }, 5000);
      } catch (e) {
        alert('ระบบรับเงินมีปัญหา กรุณาทำรายการใหม่');
        this.$store.state.IDWallet = null;
        this.$store.state.timeOut = 0;
        this.$router.go(-1);
      }
    }
  },
  mounted: function mounted() {
    this.ReceiveMoney();
    this.checkTime();
  }
});

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/stop.5b6d3b3.png";

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qrcode_vue__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__service_services__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert2__);






/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['time', 'saleTypeText'],
  components: {
    QrcodeVue: __WEBPACK_IMPORTED_MODULE_3_qrcode_vue__["a" /* default */]
  },
  data: function data() {
    return {
      qrcode: '',
      pp: {
        sku_id: 4,
        image_name: 'promptpay',
        color: 'badge-info',
        goto: 'QRpay',
        image_path: __webpack_require__(149),
        title_name: [{
          name_id: 0,
          name: 'Prompt Pay',
          say: 'Payment By Prompt Pay'
        }, {
          name_id: 1,
          name: 'พรอมเพย์',
          say: 'ชำระเงินผ่านระบบพรอมเพย์'
        }, {
          name_id: 2,
          name: '及时付款',
          say: '通過即時支付付款'
        }]
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapState */])(['isLoading', 'SaleID'])),
  methods: {
    checkTime: function checkTime() {
      var _this = this;

      this.$store.state.loopPP = setInterval(function () {
        _this.checkPromptpay();
        if (_this.time == 0) {
          if (_this.$store.state.AmountPayment >= _this.$store.state.total) {} else {
            clearInterval(_this.$store.state.loopPP);
          }
        }
      }, 1000);
    },
    genqrcode: function genqrcode() {
      var _this2 = this;

      this.$store.state.isLoading = true;

      var header = {
        headers: {
          'x-access-token': this.$store.state.accessToken
        }
      };

      if (this.$store.state.SaleID == 1) {
        var payload = {
          vending_uuid: this.$store.state.UUID,
          order_uuid: this.$store.state.txn_id,
          amount: 0,
          client_name: this.$store.state.config.client.branch,
          terminal_id: this.$store.state.config.vending.terminal_id
        };
      } else {
        var payload = {
          vending_uuid: this.$store.state.UUID,
          order_uuid: this.$store.state.txn_id,
          // amount: 0.01,
          amount: parseFloat(this.$store.state.total),
          client_name: this.$store.state.config.client.branch,
          terminal_id: this.$store.state.config.vending.terminal_id
        };
      }

      __WEBPACK_IMPORTED_MODULE_4__service_services__["a" /* default */].callqrcode(payload, header, function (result) {
        if (result.response === 'success') {
          _this2.qrcode = result.data.qr_tag;

          _this2.checkTime();
        } else {
          _this2.$store.state.isLoading = true;
          _this2.$store.state.isLoading = false;
          __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default.a.fire({
            title: 'Gen QRCode ERROR',
            text: 'สถานะการตอบกลับ ' + result.status,
            type: 'error',
            animation: true,
            showCancelButton: false,
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'OK !'
          });
        }
      }, function (error) {
        alert(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
      });
    },
    checkPromptpay: function checkPromptpay() {
      var _this3 = this;

      var header = {
        headers: {
          'x-access-token': this.$store.state.accessToken
        }
      };
      var payload = {
        vending_uuid: this.$store.state.UUID,
        order_uuid: this.$store.state.txn_id,
        amount: parseFloat(this.$store.state.total),
        client_name: this.$store.state.config.client.branch,
        terminal_id: this.$store.state.config.vending.terminal_id,
        qr_tag: this.qrcode
        // qr_tag: "sadasdasdsadasdasd"

        // console.log(payload)
      };__WEBPACK_IMPORTED_MODULE_4__service_services__["a" /* default */].checkPaymentWallet(payload, header, function (result) {
        // console.log('checkPromptpay = ', result)
        if (result.response === 'success') {
          if (result.data.status == 'completed' && result.data.method == "promptpay") {
            _this3.$store.state.AmountPayment = result.data.promptpay_confirm_result.amount;
            // if (result.data.status == 'completed') {

            _this3.$store.state.time = 0;
            _this3.$store.state.PaymentType = 3;
            clearInterval(_this3.$store.state.loopPP);
            // alert('ชำระ promptpay = ' + JSON.stringify(result))
          }
          if (result.data.status == 'completed' && (result.data.method == "pay9_debit" || result.data.method == "pay9_credit")) {
            _this3.$store.state.AmountPayment = result.data.amount;
            _this3.$store.state.memberProfile = result.data.member;
            _this3.$store.state.time = 0;
            _this3.$store.state.PaymentType = 4;
            clearInterval(_this3.$store.state.loopPP);
            // alert('ชำระ promptpay = ' + JSON.stringify(result))
          }
        } else {
          _this3.$store.state.ppError = 1;
        }
        // else {
        //   console.log('error = ', result)
        //   clearInterval(this.$store.state.loopPP)
        //   swal
        //     .fire({
        //       title: 'ระบบมีปัญหากรุณาติดต่อเจ้าหน้าที่',
        //       text:  result.message,
        //       type: 'error',
        //       allowOutsideClick: false,
        //     })
        // }
      }, function (error) {
        // alert(JSON.stringify(error))
        _this3.$store.state.ppError = 1;
      });
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    setTimeout(function () {
      _this4.genqrcode();
    }, 1000);
    // this.$store.state.PaymentType = 3
    // this.$store.state.AmountPayment = 1

    // setTimeout(() => {
    // this.$store.state.PaymentType = 4
    // }, 10000)
  }
});

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__service_services__ = __webpack_require__(16);



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      // qrcode: '',
      wal: {
        sku_id: 3,
        image_name: 'wallet',
        color: 'badge-warning',
        goto: 'Wallet',
        image_path: __webpack_require__(166),
        title_name: [{
          name_id: 0,
          name: 'E-wallet',
          say: 'Payment By E-wallet'
        }, {
          name_id: 1,
          name: 'กระเป๋าเงิน',
          say: 'ชำระเงินผ่านช่องทางกระเป๋าเงินออนไลน์'
        }, {
          name_id: 2,
          name: '钱包',
          say: '通过在线钱包付款'
        }]
      }
    };
  },

  // computed: {
  //   ...mapState(['isLoading']),
  // },
  // methods: {
  //   checkTime() {
  //     this.$store.state.loopWallet = setInterval(() => {
  //       this.checkWallet()
  //       if (this.time == 0) {
  //         clearInterval(this.$store.state.loopWallet)
  //       }
  //     }, 1000)
  //   },
  //   checkWallet() {
  //     const header = {
  //       headers: {
  //         'x-access-token': this.$store.state.accessToken
  //       }
  //     }
  //     var payload = {
  //       vending_uuid: this.$store.state.UUID,
  //       order_uuid: this.$store.state.txn_id,
  //       amount: parseFloat(this.$store.state.total),
  //       client_name: this.$store.state.config.client.branch,
  //       terminal_id: this.$store.state.config.vending.terminal_id,
  //       qr_tag: this.qrcode
  //     }
  //     api.checkPromptpay(
  //       payload,
  //       header,
  //       result => {
  //         console.log(result)
  //         if (result.Response === 'success') {
  //           if (result.data.status == 'completed' && (result.data.method == "pay9_debit" || result.data.method == "pay9_credit")) {
  //             console.log('completed = ', result)
  //             this.$store.state.time = 0
  //             this.$store.state.PaymentType = 4
  //             // alert('ชำระ promptpay = ' + JSON.stringify(result))
  //           }
  //         }
  //       },
  //       error => {
  //         alert(JSON.stringify(error))
  //       }
  //     )
  //   }
  // },
  mounted: function mounted() {}
});

/***/ }),
/* 166 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert2__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_sweetalert2__);


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['time', 'saleTypeText'],
  data: function data() {
    return {
      timerInterval: '',
      cdt: {
        sku_id: 2,
        image_name: 'credit',
        color: 'badge-danger',
        goto: 'CreditCard',
        image_path: __webpack_require__(239),
        title_name: [{
          name_id: 0,
          name: 'Credit Card',
          say: 'Payment By Credit Card'
        }, {
          name_id: 1,
          name: 'บัตรเครดิต',
          say: 'ชำระเงินผ่านบัตรเครดิต'
        }, {
          name_id: 2,
          name: '信用卡',
          say: '信用卡付款'
        }]
      }
    };
  },

  methods: {
    // checkTime() {
    //   this.$store.state.loopPCR = setInterval(() => {
    //     console.log('credit time = ' + this.time)
    //     switch (this.time) {
    //       case 100: this.$socket.sendObj({
    //         command: 'edc_cancel'
    //       })
    //         console.log('edc_cancel')
    //         this.check_edc()
    //         break
    //       case 80: this.$socket.sendObj({
    //         command: 'edc_cancel'
    //       })
    //         console.log('edc_cancel')
    //         this.check_edc()
    //         break
    //       case 60: this.$socket.sendObj({
    //         command: 'edc_cancel'
    //       })
    //         console.log('edc_cancel')
    //         this.check_edc()
    //         break
    //       case 40: this.$socket.sendObj({
    //         command: 'edc_cancel'
    //       })
    //         console.log('edc_cancel')
    //         this.check_edc()
    //         break
    //       case 20: this.$socket.sendObj({
    //         command: 'edc_cancel'
    //       })
    //         console.log('edc_cancel')
    //         this.check_edc()
    //         break
    //     }
    //     if (this.time == 0) {
    //       this.$socket.sendObj({
    //         command: 'receive_close'
    //       })
    //       clearInterval(this.$store.state.loopPCR)
    //     }
    //   }, 1000)
    // },
    check_edc: function check_edc() {
      // this.$socket.sendObj({
      //   command: 'edc_status'
      // })
      // if (this.$store.state.edc_status === false) {
      //   let text = ''
      //   let title = ''
      //   switch (this.lang) {
      //     case 0:
      //       text = 'Credit card receivers are not available yet.'
      //       title = 'Warning'
      //       break
      //     case 2:
      //       text = '信用卡接收器尚不可用。'
      //       title = '通知'
      //       break
      //     default:
      //       text = 'เครื่องรับบัตรเครดิตยังไม่พร้อมใช้งาน'
      //       title = 'แจ้งเตือน'
      //       break
      //   }
      //   Swal.fire({
      //     title: title,
      //     text: text,
      //     type: 'warning',
      //     showCancelButton: false,
      //     confirmButtonColor: '#3085d6',
      //     cancelButtonColor: '#d33',
      //     confirmButtonText: 'OK'
      //   }).then((result) => {
      //     if (result.value) {
      //       this.$store.state.timeOut = 0
      //       this.$router.go(-1)
      //     }
      //   })
      // } else {
      var obj = {
        command: 'edc_sale',
        data: '{"reference_no\":\"KL_001\", \"developer_id\":\"8237DB87A0\", \"amount\":' + parseInt(this.$store.state.total + '00') + '}'
      };
      this.$socket.sendObj(obj);
      // }
    },
    Resend_edc: function Resend_edc() {
      var _this = this;

      this.$store.state.edc_step = 0;
      var obj = {
        command: 'edc_sale',
        data: '{"reference_no\":\"KL_001\", \"developer_id\":\"8237DB87A0\", \"amount\":' + parseInt(this.$store.state.total + '00') + '}'
      };
      this.$socket.sendObj(obj);
      __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default.a.fire({
        title: 'กรุณาเสียบบัตรเครดิตของท่าน',
        text: 'Please insert your card.',
        type: 'warning',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'ยกเลิก',
        allowOutsideClick: false,
        onBeforeOpen: function onBeforeOpen() {
          _this.timerInterval = setInterval(function () {
            if (_this.$store.state.edc_step == 1) {
              clearInterval(_this.timerInterval);
              _this.$store.state.edc_step = 0;
              _this.closePop();
            }
            if (_this.$store.state.PaymentType == 2) {
              clearInterval(_this.timerInterval);
              _this.$store.state.edc_step = 0;
              __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default.a.close();
            }
          }, 500);
        }
        // onClose: () => {
        //   clearInterval(this.timerInterval)
        // }
      }).then(function (result) {
        clearInterval(_this.timerInterval);
        _this.$socket.sendObj({
          command: 'edc_cancel'
        });
      });
    },
    closePop: function closePop() {
      __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default.a.fire({
        position: 'center',
        type: 'error',
        title: 'Time Out',
        showConfirmButton: false,
        timer: 2000
      });
    },
    payment: function payment() {
      var _this2 = this;

      if (this.$store.state.edc_status === true) {
        if (parseInt(this.$store.state.AmountPayment) > 0) {
          this.$router.push({
            name: 'ProcessCredit'
          });
        }
      } else {
        var text = '';
        var title = '';
        switch (this.lang) {
          case 0:
            text = 'Credit card receivers are not available yet.';
            title = 'Warning';
            break;
          case 2:
            text = '信用卡接收器尚不可用。';
            title = '通知';
            break;
          default:
            text = 'เครื่องรับบัตรเครดิตยังไม่พร้อมใช้งาน';
            title = 'แจ้งเตือน';
            break;
        }
        __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default.a.fire({
          title: title,
          text: text,
          type: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'OK'
        }).then(function (result) {
          if (result.value) {
            _this2.$socket.sendObj({
              command: 'edc_status'
            });
          }
        });
      }
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__service_services__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert2__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_sweetalert2__);









/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            walletChangeID: [{
                data: ''
            }, {
                data: ''
            }, {
                data: ''
            }, {
                data: '-'
            }, {
                data: ''
            }, {
                data: ''
            }, {
                data: ''
            }, {
                data: '-'
            }, {
                data: ''
            }, {
                data: ''
            }, {
                data: ''
            }, {
                data: ''
            }],
            numberID: '',
            fac_change: 0
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapState */])(['isLoading', 'UUID', 'lang', 'IDWallet', 'SaleID', 'SaleType', 'PaymentType', 'accessToken', 'AmountPayment', 'reponseStatus', 'sale_info', 'printer_step', 'sale_pay', 'config', 'sale_subs_slip', 'memberProfile', 'flag_cash']), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapMutations */])(['onMessageWs'])),
    methods: {
        addAmount: function addAmount(int) {
            this.Soundclick();

            // console.log("walletChangeID",this.walletChangeID)
            if (this.numberID.length < 12) {
                this.numberID += int.toString();
                this.walletChangeID[this.numberID.length - 1]['data'] = int;
                if (this.numberID.length == 3 || this.numberID.length == 7) {
                    this.numberID += '-';
                    this.walletChangeID[this.numberID.length - 1]['data'] = '-';
                }
            }
        },
        del: function del() {
            if (this.numberID.length > 0) {
                if (this.numberID.length == 4 || this.numberID.length == 8) {
                    this.numberID = this.numberID.substring(0, this.numberID.length - 2);
                    this.walletChangeID[this.numberID.length]['data'] = '';
                } else {
                    this.numberID = this.numberID.substring(0, this.numberID.length - 1);
                    this.walletChangeID[this.numberID.length]['data'] = '';
                }
            }
        },
        checkMobile: function checkMobile(val) {
            this.Soundclick();

            if (this.$store.state.memberProfile != null) {
                if (this.$store.state.memberProfile.phone_number.substring(0, 3) == "+66") {
                    var str = this.$store.state.memberProfile.phone_number;
                    var cutBack = str.substring(3, 12);
                    var phone_number = "0" + cutBack;
                } else {
                    var phone_number = this.$store.state.memberProfile.phone_number;
                }

                this.$store.state.IDWallet = phone_number;
                if (this.$store.state.AmountPayment < this.$store.state.total) {
                    this.refund();
                } else {
                    __WEBPACK_IMPORTED_MODULE_6_jquery___default()('#Refurd').modal('hide');
                    switch (this.$store.state.PaymentType) {
                        case 1:
                            this.$router.push('/processcash');
                            break;
                        case 2:
                            this.$router.push('/processcredit');
                            break;
                        case 3:
                            this.$router.push('/processpromptpay');
                            break;
                    }
                }
            } else {
                if (this.numberID.length > 11) {
                    if (this.walletChangeID[0]['data'] === '0') {
                        this.$store.state.IDWallet = this.numberID.replace(/-/g, '');
                        // this.walletChangeID.forEach(val => {
                        //     if (val['data'] != '-') {
                        //         this.$store.state.IDWallet += val['data']
                        //     }
                        // })
                        if (this.$store.state.AmountPayment < this.$store.state.total) {
                            this.refund();
                        } else {
                            __WEBPACK_IMPORTED_MODULE_6_jquery___default()('#Refurd').modal('hide');
                            switch (this.$store.state.PaymentType) {
                                case 1:
                                    this.$router.push('/processcash');
                                    break;
                                case 2:
                                    this.$router.push('/processcredit');
                                    break;
                                case 3:
                                    this.$router.push('/processpromptpay');
                                    break;
                                case 4:
                                    this.$router.push('/processwallet');
                                    break;
                            }
                        }
                    } else {
                        var text = '';
                        var title = '';
                        switch (this.lang) {
                            case 0:
                                text = 'Please enter the ID Wallet you want to fill.';
                                title = 'Warning';
                                break;
                            case 2:
                                text = '請輸入您要填寫的代碼。';
                                title = '通知';
                                break;
                            default:
                                text = 'กรุณากรอกรหัส Wallet หรือ เบอร์โทรศัพท์ ให้ถูกต้อง';
                                title = 'แจ้งเตือน';
                                break;
                        }
                        __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()(title, text, 'warning');
                    }
                } else {
                    var _text = '';
                    var _title = '';
                    switch (this.lang) {
                        case 0:
                            _text = 'Please enter the ID Wallet you want to fill.';
                            _title = 'Warning';
                            break;
                        case 2:
                            _text = '請輸入您要填寫的代碼。';
                            _title = '通知';
                            break;
                        default:
                            _text = 'กรุณากรอกเบอร์โทรศัพท์ ให้ถูกต้อง';
                            _title = 'แจ้งเตือน';
                            break;
                    }
                    __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()(_title, _text, 'warning');
                }
            }
        },
        switchPayment: function switchPayment() {
            this.$store.state.flag_cash = 1;
            // this.$store.state.IDWallet = '0613351889'
            this.$store.state.IDWallet = this.$store.state.config.client.telephone;
            if (this.$store.state.AmountPayment < this.$store.state.total) {
                this.refund();
            } else {
                __WEBPACK_IMPORTED_MODULE_6_jquery___default()('#Refurd').modal('hide');
                switch (this.$store.state.PaymentType) {
                    case 1:
                        this.$router.push('/processcash');
                        break;
                    case 2:
                        this.$router.push('/processcredit');
                        break;
                    case 3:
                        this.$router.push('/processpromptpay');
                        break;
                    case 4:
                        this.$router.push('/processwallet');
                        break;
                }
            }
        },
        refund: function refund() {
            var _this = this;

            this.$store.state.SaleID = 1;

            this.Soundclick();
            __WEBPACK_IMPORTED_MODULE_6_jquery___default()('#Refurd').modal('hide');
            var header = {
                headers: {
                    'x-access-token': this.accessToken
                }
            };

            if (this.$store.state.SaleID == 1) {
                var mode = 'Deposit';
                var payment_type_text = 'cash';
                var type_text = 'Wallet';
                switch (this.lang) {
                    case 0:
                        payment_type_text = 'cash';
                        type_text = 'Wallet';
                        mode = 'Deposit';
                        break;
                    case 1:
                        payment_type_text = 'เงินสด';
                        type_text = 'เติมเงิน Wallet';
                        mode = 'เติมเงิน';
                        break;
                    case 2:
                        payment_type_text = '現金';
                        type_text = 'Wallet';
                        mode = '存款';
                        break;
                }
                this.$store.state.sale_subs = [{
                    line: 1,
                    item_id: '0',
                    item_name: payment_type_text,
                    qty: 1,
                    price_id: 1,
                    price_name: type_text,
                    price: parseFloat(this.$store.state.AmountPayment),
                    unit: ''
                }];
            }

            if (this.$store.state.SaleID !== 5) {
                this.$store.state.ref_number = this.$store.state.txn_id;
                this.status_partner = false;
            } else {
                this.status_partner = true;
            }
            var numberPhone = this.$store.state.IDWallet.substring(1, this.$store.state.IDWallet.length);

            var payload = {
                shift_uuid: this.$store.state.shift_uuid,
                ref_number: this.$store.state.ref_number,
                txn_id: this.$store.state.txn_id,
                type: 'deposit_cash',
                partner: this.status_partner,
                member_phone: '+66' + numberPhone,
                amount: parseFloat(this.$store.state.AmountPayment),
                payment_received: parseFloat(this.$store.state.AmountPayment),
                payment_change: 0,
                flag_cash: 0,
                flag_member: this.$store.state.flag_member,
                payment: {
                    currency: 'THB',
                    b1000: this.sale_pay.b1000,
                    b500: this.sale_pay.b500,
                    b100: this.sale_pay.b100,
                    b50: this.sale_pay.b50,
                    b20: this.sale_pay.b20,
                    c10: this.sale_pay.c10,
                    c5: this.sale_pay.c5,
                    c2: this.sale_pay.c2,
                    c1: this.sale_pay.c1,
                    c050: 0,
                    c025: 0
                },
                pay_change: {
                    b1000: 0,
                    b500: 0,
                    b100: 0,
                    b50: 0,
                    b20: 0,
                    c10: 0,
                    c5: 0,
                    c2: 0,
                    c1: 0,
                    c050: 0,
                    c025: 0
                },
                items: this.$store.state.sale_subs
            };

            this.$store.state.isLoading = true;
            __WEBPACK_IMPORTED_MODULE_5__service_services__["a" /* default */].closeSaleV2(payload, header, function (result) {
                if (result.response == 'success') {
                    _this.$socket.sendObj({
                        command: 'receive_close'
                    });
                    if (_this.$store.state.SaleID == 5) {
                        var obj = {
                            ref_number: _this.$store.state.ref_number,
                            status: 'PROCESSING'
                        };
                        __WEBPACK_IMPORTED_MODULE_5__service_services__["a" /* default */].getReceiveC9(obj, header, function (result) {
                            var text = '';
                            var title = '';
                            switch (_this.lang) {
                                case 0:
                                    text = 'Already refunded to your wallet.';
                                    title = 'Process';
                                    break;
                                case 2:
                                    text = '已退還到您的錢包';
                                    title = '處理';
                                    break;
                                default:
                                    text = 'คืนเงินเข้ากระเป๋าเงินของท่านเรียบร้อยแล้ว';
                                    title = 'ประมวลผล';
                                    break;
                            }
                            __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()(title, text, 'success');
                            _this.$router.push({
                                name: 'Main'
                            });
                        }, function (error) {
                            alert(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
                        });
                    } else {
                        if (_this.$store.state.acl === 1) {
                            _this.$socket.sendObj({
                                command: 'open_cash_box',
                                data: 10
                            });
                        }
                        var text = '';
                        var title = '';
                        switch (_this.lang) {
                            case 0:
                                text = 'Already refunded to your wallet.';
                                title = 'Process';
                                break;
                            case 2:
                                text = '已退還到您的錢包';
                                title = '處理';
                                break;
                            default:
                                text = 'คืนเงินเข้ากระเป๋าเงินของท่านเรียบร้อยแล้ว';
                                title = 'ประมวลผล';
                                break;
                        }
                        __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default()(title, text, 'success');
                        _this.$router.push({
                            name: 'Main'
                        });
                    }
                } else {
                    alert(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(result));
                }
                _this.$store.state.isLoading = false;
            }, function (error) {
                _this.$store.state.isLoading = false;
                alert(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
            });
        }
    },
    mounted: function mounted() {
        // if (this.$store.state.IDWallet != null && this.$store.state.SaleID == 1) {
        //   this.$router.push('/processcash')
        // }
    }
});

/***/ }),
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(228);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(64)("651c3e91", content, true, {});

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(63)(true);
// imports


// module
exports.push([module.i, "h1{color:#fff}.menu h2{font-size:40px;line-height:30px;color:#fff!important}.select-item{background:#fff;border-radius:5px;padding-bottom:0;width:90%;height:100%;background-position:50%;background-size:cover;position:relative}.type_description{width:100%;background:#000;opacity:.9;filter:alpha(opacity=100);position:absolute;bottom:-10px}.type_description h2,h3{color:#fff}", "", {"version":3,"sources":["C:/Users/imkeeper/Desktop/Paybox/ui/C9/src/components/Type.vue"],"names":[],"mappings":"AACA,GACE,UAAY,CACb,AACD,SACE,eAAgB,AAChB,iBAAkB,AAClB,oBAAsB,CACvB,AACD,aACE,gBAAiB,AACjB,kBAAmB,AACnB,iBAAkB,AAClB,UAAW,AACX,YAAa,AACb,wBAA4B,AAC5B,sBAAuB,AACvB,iBAAmB,CACpB,AACD,kBACE,WAAY,AACZ,gBAAiB,AACjB,WAAa,AACb,0BAA2B,AAC3B,kBAAmB,AACnB,YAAc,CACf,AACD,wBACE,UAAY,CACb","file":"Type.vue","sourcesContent":["\nh1 {\r\n  color: #fff;\n}\n.menu h2 {\r\n  font-size: 40px;\r\n  line-height: 30px;\r\n  color: #fff!important;\n}\n.select-item {\r\n  background: #fff;\r\n  border-radius: 5px;\r\n  padding-bottom: 0;\r\n  width: 90%;\r\n  height: 100%;\r\n  background-position: center;\r\n  background-size: cover;\r\n  position: relative;\n}\n.type_description {\r\n  width: 100%;\r\n  background: #000;\r\n  opacity: 0.9;\r\n  filter: alpha(opacity=100);\r\n  position: absolute;\r\n  bottom: -10px;\n}\n.type_description h2,h3 {\r\n  color: #fff;\n}\r\n\r\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_js_type_cash_js__ = __webpack_require__(162);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_270786ca_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TypeCach_vue__ = __webpack_require__(232);
function injectStyle (ssrContext) {
  __webpack_require__(230)
}
var normalizeComponent = __webpack_require__(13)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_js_type_cash_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_270786ca_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TypeCach_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(231);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(64)("0b898396", content, true, {});

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(63)(true);
// imports


// module
exports.push([module.i, "#cash{position:relative}#Amount{position:absolute;width:100%;text-align:center;left:0;top:20px;font-size:100px;font-weight:700;color:#fa840f;text-shadow:2px 2px #555}.slide-fade-enter-active{-webkit-transition:all .1s ease;transition:all .1s ease}.slide-fade-leave-active{-webkit-transition:all .2s cubic-bezier(1,.5,.8,1);transition:all .2s cubic-bezier(1,.5,.8,1)}.slide-fade-enter,.slide-fade-leave-to{-webkit-transform:translateX(10px);transform:translateX(10px);opacity:0}", "", {"version":3,"sources":["C:/Users/imkeeper/Desktop/Paybox/ui/C9/src/components/payment/TypeCach.vue"],"names":[],"mappings":"AACA,MACE,iBAAmB,CACpB,AACD,QACE,kBAAmB,AACnB,WAAY,AACZ,kBAAmB,AACnB,OAAU,AACV,SAAU,AACV,gBAAiB,AACjB,gBAAkB,AAClB,cAAe,AACf,wBAA0B,CAC3B,AACD,yBACE,gCAAkC,AAClC,uBAA0B,CAC3B,AACD,yBACE,mDAA0D,AAC1D,0CAAkD,CACnD,AACD,uCAEE,mCAAoC,AAC5B,2BAA4B,AACpC,SAAW,CACZ","file":"TypeCach.vue","sourcesContent":["\n#cash {\r\n  position: relative;\n}\n#Amount {\r\n  position: absolute;\r\n  width: 100%;\r\n  text-align: center;\r\n  left: 0px;\r\n  top: 20px;\r\n  font-size: 100px;\r\n  font-weight: bold;\r\n  color: #fa840f;\r\n  text-shadow: 2px 2px #555;\n}\n.slide-fade-enter-active {\r\n  -webkit-transition: all 0.1s ease;\r\n  transition: all 0.1s ease;\n}\n.slide-fade-leave-active {\r\n  -webkit-transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);\r\n  transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);\n}\n.slide-fade-enter, .slide-fade-leave-to\r\n  /* .slide-fade-leave-active for <2.1.8 */ {\r\n  -webkit-transform: translateX(10px);\r\n          transform: translateX(10px);\r\n  opacity: 0;\n}\r\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"cash"}},[_c('img',{staticStyle:{"width":"70%","margin":"5px 0px"},attrs:{"src":_vm.cash.image_path}}),_vm._v(" "),_vm._l((_vm.cash.title_name),function(t,i){return _c('h1',{directives:[{name:"show",rawName:"v-show",value:(t.name_id == _vm.$store.state.lang),expression:"t.name_id == $store.state.lang"}],key:'c' + i,staticStyle:{"color":"#555"}},[_vm._v(_vm._s(t.name))])}),_vm._v(" "),(_vm.$store.state.AmountPayment > 0 && _vm.$store.state.PaymentType != 1)?_c('img',{staticStyle:{"width":"90%","margin":"15px 0px","position":"absolute","top":"0px","left":"15px"},attrs:{"src":__webpack_require__(163)}}):_vm._e(),_vm._v(" "),(_vm.$store.state.AmountPayment != 0 && _vm.$store.state.PaymentType == 1)?_c('transition',{attrs:{"name":"slide-fade","mode":"out-in"}},[_c('div',{key:_vm.$store.state.AmountPayment,attrs:{"id":"Amount"}},[_vm._v(_vm._s(_vm.$store.state.AmountPayment))])]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_js_type_promptpay_js__ = __webpack_require__(164);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c35ff97c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TypePromptpay_vue__ = __webpack_require__(234);
var normalizeComponent = __webpack_require__(13)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_js_type_promptpay_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c35ff97c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TypePromptpay_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pt-2",staticStyle:{"position":"relative"},attrs:{"id":"promptpay"}},[(_vm.$store.state.AmountPayment == 0 || _vm.$store.state.PaymentType == 3 || _vm.$store.state.PaymentType == 4)?_c('qrcode-vue',{attrs:{"value":_vm.qrcode,"size":250,"level":"H"}}):_vm._e(),_vm._v(" "),(_vm.$store.state.AmountPayment != 0 && _vm.$store.state.PaymentType != 3 || _vm.$store.state.ppError == 1)?_c('img',{attrs:{"src":__webpack_require__(235),"width":"250"}}):_vm._e(),_vm._v(" "),(_vm.$store.state.AmountPayment != 0 && _vm.$store.state.PaymentType == 3 || _vm.$store.state.PaymentType == 4)?_c('transition',{attrs:{"name":"slide-fade","mode":"out-in"}},[_c('div',{key:_vm.$store.state.AmountPayment,attrs:{"id":"Amount"}},[_vm._v(_vm._s(_vm.$store.state.AmountPayment))])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/stopqr.e405848.jpg";

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_js_type_wallet_js__ = __webpack_require__(165);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b8ed219e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TypeWallet_vue__ = __webpack_require__(237);
var normalizeComponent = __webpack_require__(13)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_js_type_wallet_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b8ed219e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TypeWallet_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"wallet"}},[_c('img',{staticStyle:{"width":"90%","margin":"15px 0px"},attrs:{"src":__webpack_require__(166)}}),_vm._v(" "),_c('h4',[_vm._v("Pay9-wallet OR "),_c('br'),_vm._v("Prompt Pay")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_js_type_credit_js__ = __webpack_require__(167);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56226f28_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TypeCredit_vue__ = __webpack_require__(240);
var normalizeComponent = __webpack_require__(13)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_js_type_credit_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56226f28_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TypeCredit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/visa.d09079c.png";

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative"},attrs:{"id":"promptpay"}},[_c('img',{staticStyle:{"width":"90%","margin":"15px 0px"},attrs:{"src":_vm.cdt.image_path},on:{"click":function($event){_vm.Resend_edc()}}}),_vm._v(" "),_vm._l((_vm.cdt.title_name),function(t,i){return _c('h1',{directives:[{name:"show",rawName:"v-show",value:(t.name_id == _vm.$store.state.lang),expression:"t.name_id == $store.state.lang"}],key:'c' + i,staticStyle:{"color":"#555"}},[_vm._v(_vm._s(t.name))])}),_vm._v(" "),(_vm.$store.state.AmountPayment != 0 && _vm.$store.state.PaymentType != 2> 0 )?_c('img',{staticStyle:{"width":"90%","margin":"15px 0px","position":"absolute","top":"0px","left":"15px"},attrs:{"src":__webpack_require__(163)}}):_vm._e(),_vm._v(" "),(_vm.$store.state.AmountPayment != 0 && _vm.$store.state.PaymentType == 2)?_c('transition',{attrs:{"name":"slide-fade","mode":"out-in"}},[_c('div',{key:_vm.$store.state.AmountPayment,attrs:{"id":"Amount"}},[_vm._v(_vm._s(_vm.$store.state.AmountPayment))])]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_js_modal_refund_js__ = __webpack_require__(168);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f2cd8c8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_refundpad_vue__ = __webpack_require__(244);
function injectStyle (ssrContext) {
  __webpack_require__(242)
}
var normalizeComponent = __webpack_require__(13)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7f2cd8c8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_js_modal_refund_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f2cd8c8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_refundpad_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(243);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(64)("6402684e", content, true, {});

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(63)(true);
// imports


// module
exports.push([module.i, "body[data-v-7f2cd8c8]{padding-top:0!important;overflow:hidden!important}.input-money[data-v-7f2cd8c8]{border:10px solid red;border-radius:10px;padding-top:15px}.description[data-v-7f2cd8c8],.input-money[data-v-7f2cd8c8]{width:100%;background:#fff;height:130px;overflow:hidden;margin:0}.description[data-v-7f2cd8c8]{border:5px solid gray!important;border-radius:10px;padding-top:5px}.ID[data-v-7f2cd8c8]{width:95px;padding-top:5px;padding-bottom:0;margin-left:2.5px;border:2px solid #000;border-radius:4px}.ID-BB[data-v-7f2cd8c8]{border:0}.BG[data-v-7f2cd8c8]{background:#dfc}.BGR[data-v-7f2cd8c8]{background:#f27b7b}.btn-w-pad[data-v-7f2cd8c8]{width:100%;height:90px;background:#1f1f14!important;font-size:80px;line-height:90px;color:#fff}.btn-w-pad[data-v-7f2cd8c8]:active{background:#c2c2a3!important;border:0;color:#000}", "", {"version":3,"sources":["C:/Users/imkeeper/Desktop/Paybox/ui/C9/src/components/modal/refundpad.vue"],"names":[],"mappings":"AACA,sBACE,wBAA4B,AAC5B,yBAA2B,CAC5B,AACD,8BAGE,sBAAuB,AAEvB,mBAAoB,AACpB,gBAAkB,CAGnB,AACD,4DATE,WAAY,AACZ,gBAAiB,AAEjB,aAAc,AAGd,gBAAiB,AACjB,QAAY,CAWb,AATD,8BAGE,gCAAkC,AAElC,mBAAoB,AACpB,eAAiB,CAGlB,AACD,qBACE,WAAY,AACZ,gBAAiB,AACjB,iBAAoB,AACpB,kBAAmB,AACnB,sBAAuB,AACvB,iBAAmB,CACpB,AACD,wBACE,QAAY,CACb,AACD,qBACE,eAAoB,CACrB,AACD,sBACE,kBAAoB,CACrB,AACD,4BACE,WAAY,AACZ,YAAa,AACb,6BAA+B,AAC/B,eAAgB,AAChB,iBAAkB,AAClB,UAAY,CACb,AACD,mCACE,6BAA+B,AAC/B,SAAY,AACZ,UAAY,CACb","file":"refundpad.vue","sourcesContent":["\nbody[data-v-7f2cd8c8] {\r\n  padding-top: 0px !important;\r\n  overflow: hidden!important;\n}\n.input-money[data-v-7f2cd8c8] {\r\n  width: 100%;\r\n  background: #fff;\r\n  border: 10px solid red;\r\n  height: 130px;\r\n  border-radius: 10px;\r\n  padding-top: 15px;\r\n  overflow: hidden;\r\n  margin: 0px;\n}\n.description[data-v-7f2cd8c8] {\r\n  width: 100%;\r\n  background: #fff;\r\n  border: 5px solid gray !important;\r\n  height: 130px;\r\n  border-radius: 10px;\r\n  padding-top: 5px;\r\n  overflow: hidden;\r\n  margin: 0px;\n}\n.ID[data-v-7f2cd8c8] {\r\n  width: 95px;\r\n  padding-top: 5px;\r\n  padding-bottom: 0px;\r\n  margin-left: 2.5px;\r\n  border: 2px solid #000;\r\n  border-radius: 4px;\n}\n.ID-BB[data-v-7f2cd8c8] {\r\n  border: 0px;\n}\n.BG[data-v-7f2cd8c8] {\r\n  background: #ddffcc;\n}\n.BGR[data-v-7f2cd8c8] {\r\n  background: #f27b7b;\n}\n.btn-w-pad[data-v-7f2cd8c8] {\r\n  width: 100%;\r\n  height: 90px;\r\n  background: #1f1f14 !important;\r\n  font-size: 80px;\r\n  line-height: 90px;\r\n  color: #fff;\n}\n.btn-w-pad[data-v-7f2cd8c8]:active {\r\n  background: #c2c2a3 !important;\r\n  border: 0px;\r\n  color: #000;\n}\r\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":"Refurd","tabindex":"-1","role":"dialog","aria-labelledby":"exampleModalScrollableTitle","aria-hidden":"true"}},[(this.$store.state.memberProfile == null || _vm.fac_change == 1)?_c('div',{staticClass:"modal-dialog modal-dialog-centered",staticStyle:{"max-width":"1024px"},attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content",staticStyle:{"width":"950px","left":"30px","top":"-20px","height":"585px"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal-body",staticStyle:{"overflow":"hidden"}},[_c('div',{staticClass:"d-flex justify-content-around"},_vm._l((_vm.walletChangeID),function(w,i){return _c('span',{key:i,staticClass:"ID",class:{ 'ID-BB': i == 3 || i == 7, 'BG': w.data != '' && w.data != '-', 'BGR': _vm.walletChangeID[0]['data'] != '0' &&  _vm.walletChangeID[0]['data'] != '' && _vm.walletChangeID[0]['data'] != '-'}},[_c('b',{staticStyle:{"font-size":"80px","line-height":"50px"}},[_vm._v(_vm._s(w.data))])])}),0),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"padding-top":"10px"}},[_c('div',{staticClass:"col-6",staticStyle:{"padding-top":"10px"}},[_c('div',{staticClass:"row",staticStyle:{"padding-left":"5%","padding-right":"5%"}},[_c('div',{staticClass:"col p-0"},[_c('div',{staticClass:"btn-w-pad",staticStyle:{"border-right":"2px solid #fff"},on:{"click":function($event){_vm.addAmount('1')}}},[_vm._v("1")])]),_vm._v(" "),_c('div',{staticClass:"col p-0"},[_c('div',{staticClass:"btn-w-pad",staticStyle:{"border-right":"2px solid #fff"},on:{"click":function($event){_vm.addAmount('2')}}},[_vm._v("2")])]),_vm._v(" "),_c('div',{staticClass:"col p-0"},[_c('div',{staticClass:"btn-w-pad",on:{"click":function($event){_vm.addAmount('3')}}},[_vm._v("3")])])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"padding-left":"5%","padding-right":"5%"}},[_c('div',{staticClass:"col p-0"},[_c('div',{staticClass:"btn-w-pad",staticStyle:{"border-right":"2px solid #fff","border-top":"2px solid #fff"},on:{"click":function($event){_vm.addAmount('4')}}},[_vm._v("4")])]),_vm._v(" "),_c('div',{staticClass:"col p-0"},[_c('div',{staticClass:"btn-w-pad",staticStyle:{"border-right":"2px solid #fff","border-top":"2px solid #fff"},on:{"click":function($event){_vm.addAmount('5')}}},[_vm._v("5")])]),_vm._v(" "),_c('div',{staticClass:"col p-0"},[_c('div',{staticClass:"btn-w-pad",staticStyle:{"border-top":"2px solid #fff"},on:{"click":function($event){_vm.addAmount('6')}}},[_vm._v("6")])])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"padding-left":"5%","padding-right":"5%"}},[_c('div',{staticClass:"col p-0"},[_c('div',{staticClass:"btn-w-pad",staticStyle:{"border-right":"2px solid #fff","border-top":"2px solid #fff"},on:{"click":function($event){_vm.addAmount('7')}}},[_vm._v("7")])]),_vm._v(" "),_c('div',{staticClass:"col p-0"},[_c('div',{staticClass:"btn-w-pad",staticStyle:{"border-right":"2px solid #fff","border-top":"2px solid #fff"},on:{"click":function($event){_vm.addAmount('8')}}},[_vm._v("8")])]),_vm._v(" "),_c('div',{staticClass:"col p-0"},[_c('div',{staticClass:"btn-w-pad",staticStyle:{"border-top":"2px solid #fff"},on:{"click":function($event){_vm.addAmount('9')}}},[_vm._v("9")])])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"padding-left":"5%","padding-right":"5%"}},[_c('div',{staticClass:"col p-0"},[_c('div',{staticClass:"btn-w-pad",staticStyle:{"border-right":"2px solid #fff","border-top":"2px solid #fff"},on:{"click":function($event){_vm.addAmount('0')}}},[_vm._v("0")])]),_vm._v(" "),_c('div',{staticClass:"col p-0"},[_c('div',{staticClass:"btn-w-pad",staticStyle:{"border-top":"2px solid #fff"},on:{"click":_vm.del}},[_vm._v("DEL")])])])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body",staticStyle:{"border":"5px solid red","background":"#000"}},[_c('div',{staticClass:"text-left text-white",staticStyle:{"font-size":"24px"}},[(_vm.$store.state.lang == 0)?_c('b',[_vm._v("Suggestion")]):_vm._e(),_vm._v(" "),(_vm.$store.state.lang == 1)?_c('b',[_vm._v("คำแนะนำ")]):_vm._e(),_vm._v(" "),(_vm.$store.state.lang == 2)?_c('b',[_vm._v("領導")]):_vm._e()]),_vm._v(" "),_c('hr',{staticStyle:{"margin":"0","border":"1px solid white","margin-bottom":"10px"}}),_vm._v(" "),_c('p',{staticClass:"text-left text-white",staticStyle:{"font-size":"20px"}},[(_vm.$store.state.lang == 0)?_c('span',[_vm._v("1. Please enter your phone number to receive the change to Walt.")]):_vm._e(),_vm._v(" "),(_vm.$store.state.lang == 1)?_c('span',[_vm._v("1. กรุณากรอกรหัสเบอร์โทรเพื่อรับเงินทอนเข้าวอเล็ต")]):_vm._e(),_vm._v(" "),(_vm.$store.state.lang == 2)?_c('span',[_vm._v("1. 请输入您的电话号码以接收Walt的更改。")]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.$store.state.lang == 0)?_c('span',[_vm._v("2. Press the \"Change to wallet\" button. Receive change to the wallet.")]):_vm._e(),_vm._v(" "),(_vm.$store.state.lang == 1)?_c('span',[_vm._v("2. กดปุ่ม \"ทอนเข้าวอเล็ต\" รับเงินทอนเข้าวอเล็ต")]):_vm._e(),_vm._v(" "),(_vm.$store.state.lang == 2)?_c('span',[_vm._v("2. 按“更改为钱包”按钮。接收钱包的更改。")]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.$store.state.lang == 0)?_c('span',[_vm._v("3. Click the \"Change cash\" button. Receive change in cash.")]):_vm._e(),_vm._v(" "),(_vm.$store.state.lang == 1)?_c('span',[_vm._v("3. กดปุ่ม \"ทอนเงินสด\" รับเงินทอนเป็นเงินสด")]):_vm._e(),_vm._v(" "),(_vm.$store.state.lang == 2)?_c('span',[_vm._v("3. 点击“更改现金”按钮。接收现金变化。")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"padding":"2% 5% 0% 5%"}},[(_vm.SaleID != 1 && this.$store.state.AmountPayment >= this.$store.state.total)?_c('div',{staticClass:"menu badge-success",staticStyle:{"width":"45%","height":"135px","margin-top":"0px","text-align":"center"},on:{"click":function($event){_vm.switchPayment()}}},[_c('img',{staticStyle:{"margin-bottom":"5px"},attrs:{"src":__webpack_require__(136),"width":"80"}}),_vm._v(" "),(_vm.$store.state.lang == 0)?_c('h2',[_vm._v("Cash")]):_vm._e(),_vm._v(" "),(_vm.$store.state.lang == 1)?_c('h2',[_vm._v("เงินสด")]):_vm._e(),_vm._v(" "),(_vm.$store.state.lang == 2)?_c('h2',[_vm._v("现金")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.SaleID != 1 && this.$store.state.AmountPayment >= this.$store.state.total)?_c('div',{staticClass:"menu badge-success",staticStyle:{"width":"45%","height":"135px","margin-top":"0px","text-align":"center"},on:{"click":function($event){_vm.checkMobile()}}},[_c('img',{staticStyle:{"margin-bottom":"5px"},attrs:{"src":__webpack_require__(130),"width":"80"}}),_vm._v(" "),(_vm.$store.state.lang == 0)?_c('h2',[_vm._v("Wallet")]):_vm._e(),_vm._v(" "),(_vm.$store.state.lang == 1)?_c('h2',[_vm._v("วอลเล็ต")]):_vm._e(),_vm._v(" "),(_vm.$store.state.lang == 2)?_c('h2',[_vm._v("钱包")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.SaleID == 1)?_c('div',{staticClass:"menu badge-success",staticStyle:{"width":"100%","height":"135px","margin-top":"0px","text-align":"center"},on:{"click":function($event){_vm.checkMobile()}}},[_c('img',{staticStyle:{"margin-bottom":"5px"},attrs:{"src":__webpack_require__(130),"width":"80"}}),_vm._v(" "),(_vm.$store.state.lang == 0)?_c('h2',[_vm._v("Wallet")]):_vm._e(),_vm._v(" "),(_vm.$store.state.lang == 1)?_c('h2',[_vm._v("วอลเล็ต")]):_vm._e(),_vm._v(" "),(_vm.$store.state.lang == 2)?_c('h2',[_vm._v("钱包")]):_vm._e()]):_vm._e(),_vm._v(" "),(this.$store.state.AmountPayment < this.$store.state.total)?_c('div',{staticClass:"menu badge-success",staticStyle:{"width":"100%","height":"135px","margin-top":"0px","text-align":"center"},on:{"click":function($event){_vm.checkMobile()}}},[_c('img',{staticStyle:{"margin-bottom":"5px"},attrs:{"src":__webpack_require__(130),"width":"80"}}),_vm._v(" "),(_vm.$store.state.lang == 0)?_c('h2',[_vm._v("refund")]):_vm._e(),_vm._v(" "),(_vm.$store.state.lang == 1)?_c('h2',[_vm._v("คืนเงิน")]):_vm._e(),_vm._v(" "),(_vm.$store.state.lang == 2)?_c('h2',[_vm._v("退款")]):_vm._e()]):_vm._e()])])])])])]):_vm._e(),_vm._v(" "),(this.$store.state.memberProfile != null && _vm.fac_change == 0)?_c('div',{staticClass:"modal-dialog modal-dialog-centered",staticStyle:{"max-width":"1024px"},attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content",staticStyle:{"width":"900px","left":"60px"}},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"modal-body",staticStyle:{"overflow":"hidden"}},[_c('div',{staticClass:"row",staticStyle:{"padding-top":"10px"}},[_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body",staticStyle:{"border":"5px solid red","background":"#000","height":"345px"}},[_c('div',{staticClass:"text-left text-white",staticStyle:{"font-size":"24px"}},[(_vm.$store.state.lang == 0)?_c('b',[_vm._v("Suggestion")]):_vm._e(),_vm._v(" "),(_vm.$store.state.lang == 1)?_c('b',[_vm._v("คำแนะนำ")]):_vm._e(),_vm._v(" "),(_vm.$store.state.lang == 2)?_c('b',[_vm._v("領導")]):_vm._e()]),_vm._v(" "),_c('hr',{staticStyle:{"margin":"0","border":"1px solid white","margin-bottom":"10px"}}),_vm._v(" "),_c('p',{staticClass:"text-left text-white",staticStyle:{"font-size":"20px"}},[(_vm.$store.state.lang == 0)?_c('span',[_vm._v("1. Please enter your phone number to receive the change to Walt.")]):_vm._e(),_vm._v(" "),(_vm.$store.state.lang == 1)?_c('span',[_vm._v("1. กรุณากรอกรหัสเบอร์โทรเพื่อรับเงินทอนเข้าวอเล็ต")]):_vm._e(),_vm._v(" "),(_vm.$store.state.lang == 2)?_c('span',[_vm._v("1. 请输入您的电话号码以接收Walt的更改。")]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.$store.state.lang == 0)?_c('span',[_vm._v("2. Press the \"Change to wallet\" button. Receive change to the wallet.")]):_vm._e(),_vm._v(" "),(_vm.$store.state.lang == 1)?_c('span',[_vm._v("2. กดปุ่ม \"เข้าวอเล็ต\" รับเงินทอนเข้าวอเล็ต")]):_vm._e(),_vm._v(" "),(_vm.$store.state.lang == 2)?_c('span',[_vm._v("2. 按“更改为钱包”按钮。接收钱包的更改。")]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.$store.state.lang == 0)?_c('span',[_vm._v("3. Click the \"Change cash\" button. Receive change in cash.")]):_vm._e(),_vm._v(" "),(_vm.$store.state.lang == 1)?_c('span',[_vm._v("3. กดปุ่ม \"เงินสด\" รับเงินทอนเป็นเงินสด")]):_vm._e(),_vm._v(" "),(_vm.$store.state.lang == 2)?_c('span',[_vm._v("3. 点击“更改现金”按钮。接收现金变化。")]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"row",staticStyle:{"padding":"0% 0% 0% 0%","margin-top":"45px"}},[_c('div',{staticClass:"menu badge-success",staticStyle:{"width":"100%","height":"100px","margin-top":"0px","text-align":"center"},on:{"click":function($event){_vm.checkMobile()}}},[_c('div',{staticClass:"row"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-8 d-flex align-items-center"},[(_vm.$store.state.lang == 0)?_c('h3',[_vm._v("Change into wallets")]):_vm._e(),_vm._v(" "),(_vm.$store.state.lang == 1)?_c('h3',[_vm._v("เข้าวอลเล็ต")]):_vm._e(),_vm._v(" "),(_vm.$store.state.lang == 2)?_c('h3',[_vm._v("换钱包")]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"padding":"0% 0% 0% 0%","margin-top":"10px"}},[_c('div',{staticClass:"menu badge-success",staticStyle:{"width":"100%","height":"100px","margin-top":"0px","text-align":"center"},on:{"click":function($event){_vm.switchPayment()}}},[_c('div',{staticClass:"row"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-8 d-flex align-items-center"},[(_vm.$store.state.lang == 0)?_c('h3',[_vm._v("Change cash")]):_vm._e(),_vm._v(" "),(_vm.$store.state.lang == 1)?_c('h3',[_vm._v("เงินสด")]):_vm._e(),_vm._v(" "),(_vm.$store.state.lang == 2)?_c('h3',[_vm._v("兑换现金")]):_vm._e()])])])])])])])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h1',{staticStyle:{"color":"#000","padding-bottom":"0px","margin-bottom":"0px"}},[_vm._v("กรุณากรอกรหัส Wallet หรือ เบอร์โทรศัพท์มือถือ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h1',{staticStyle:{"color":"#000","padding-bottom":"0px","margin-bottom":"0px"}},[_vm._v("กรุณาเลือกวิธีการรับเงินทอน")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-4"},[_c('img',{staticStyle:{"margin-bottom":"5px"},attrs:{"src":__webpack_require__(130),"alt":"payment","width":"85"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-4"},[_c('img',{staticStyle:{"margin-bottom":"5px"},attrs:{"src":__webpack_require__(245),"alt":"payment","width":"85"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/change.ce1ad28.png";

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/no_select.ded897f.png";

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contianer"},[_c('div',{staticClass:"row"},[_c('div',{staticStyle:{"width":"42%","position":"relative"}},[_c('div',{staticClass:"type_top"},[(_vm.$store.state.SaleID == 2)?_c('h4',{staticStyle:{"font-size":"30px"}},[(_vm.$store.state.lang == 1)?_c('span',[_vm._v("Shopping")]):_vm._e(),_vm._v(" "),(_vm.$store.state.lang == 0)?_c('span',[_vm._v("ซื้อสินค้า")]):_vm._e(),_vm._v(" "),(_vm.$store.state.lang == 2)?_c('span',[_vm._v("購物")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.$store.state.SaleID == 1)?_c('h4',{staticStyle:{"font-size":"30px"}},[(_vm.$store.state.lang == 1)?_c('span',[_vm._v("เติมเงิน")]):_vm._e(),_vm._v(" "),(_vm.$store.state.lang == 0)?_c('span',[_vm._v("Deposit")]):_vm._e(),_vm._v(" "),(_vm.$store.state.lang == 2)?_c('span',[_vm._v("存款")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.$store.state.SaleID == 1)?_c('h4',[_vm._v(_vm._s(_vm.$store.state.IDWallet))]):_vm._e(),_vm._v(" "),_c('h1',{staticStyle:{"font-size":"50px","line-height":"40px"}},[_vm._v(_vm._s(_vm.money_format(_vm.$store.state.total)))])]),_vm._v(" "),_c('div',{staticClass:"type_list"},[(_vm.$store.state.SaleID != 2)?_c('div',{staticClass:"type_item d-flex justify-content-center align-items-center"},[_c('img',{attrs:{"src":_vm.itemImage}})]):_vm._e(),_vm._v(" "),(_vm.$store.state.SaleID == 2)?_c('div',{staticClass:"type_item d-flex justify-content-center align-items-start"},[_c('ul',{staticClass:"list-group",staticStyle:{"width":"100%","border":"0px","text-align":"left","font-size":"25px"}},_vm._l((_vm.$store.state.sale_subs),function(item,i){return _c('li',{key:'item' + i,staticClass:"list-group-item",staticStyle:{"border-top":"0px","border-left":"0px","border-right":"0px"}},[_vm._v("\n              "+_vm._s(i + 1)+". "+_vm._s(item.item_name)+" x "+_vm._s(item.qty)+"\n            ")])}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"type_msg"},[_vm._v("กรุณาชำระเงินภายในเวลาที่กำหนด "+_vm._s(_vm.$store.state.timeOut)+" วินาที")])])]),_vm._v(" "),_c('div',{staticStyle:{"width":"58%"}},[_c('div',{staticClass:"type_box p-3",staticStyle:{"border-bottom":"1px dashed #555"}},[_c('Typewallet')],1),_vm._v(" "),_c('div',{staticClass:"type_box p-3",staticStyle:{"border-bottom":"1px dashed #555","border-left":"1px dashed #555"}},[_c('Typepromptpay',{attrs:{"time":_vm.$store.state.timeOut,"saleText":_vm.saleTypeText}})],1),_vm._v(" "),_c('div',{staticClass:"type_box p-3"},[_c('Typecash',{attrs:{"time":_vm.$store.state.timeOut,"saleText":_vm.saleTypeText}})],1),_vm._v(" "),_c('div',{staticClass:"type_box p-3",staticStyle:{"border-left":"1px dashed #555"}},[_c('Typecredit',{attrs:{"time":_vm.$store.state.timeOut,"saleText":_vm.saleTypeText}})],1)])]),_vm._v(" "),_c('div',{staticClass:"back d-flex align-items-center justify-content-center"},[_c('img',{attrs:{"src":__webpack_require__(127),"alt":"back","width":"80"},on:{"click":_vm.back}})]),_vm._v(" "),_c('loading',{attrs:{"active":_vm.$store.state.isLoading,"can-cancel":false,"is-full-page":true},on:{"update:active":function($event){_vm.$set(_vm.$store.state, "isLoading", $event)}}}),_vm._v(" "),_c('RefurdPad')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
]));


// WEBPACK FOOTER //
// static/js/1.71591af24a4da0a73ef7.js